

import React, { useEffect, useState } from 'react'
import CreateWorkPlan from 'src/components/work_plan/CreateWorkPlan';
import { Link, useLoaderData, useNavigate } from 'react-router-dom'
import AxiosInstance from 'src/components/Axios';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { CButton, CFormInput, CFormLabel } from '@coreui/react';
import AsyncSelect from 'react-select/async';
// import { Select } from '@mui/material';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from 'react-confirm-alert';
import Select from 'react-select';
import StatusItem from 'src/components/work_plan/StatusItem';
import { Spinner } from 'react-bootstrap';

const user_data = localStorage.getItem('user_data')
const role = localStorage.getItem('user_role')
const tokenStr = localStorage.getItem('user')
const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }

const urlApi = '/work_plans'
const urlApi1 = '/work_plan_stages'
const urlApi2 = '/work_stage_types'
const urlApi3 = 'work_stage_type_workers'
const urlRouter = '/work_plans'


//таж сама функція зі спуском на рівень нижче для підгрузки машин і ОП
// export async function LoaderWorkPlanUpdate({ params }) {
//    const id = params.pid;


//    if (!id) {
//       return { data: null };
//    }

//    try {
//       // 1. Основний план
//       const response = await AxiosInstance.get(`${urlApi}/${id}`, header);
//       const workPlan = response.data;

//       // 2. Функція підгрузки
//       const fetchList = async (uris) => {
//          if (!uris || uris.length === 0) return [];

//          const requests = uris.map((uri) => {
//             const cleanUri = uri.replace(/^\/api/, '');
//             return AxiosInstance.get(cleanUri, header).then(res => res.data);
//          });

//          return Promise.all(requests);
//       };

//       // 3. Обробка рівнів
//       const normalizedStages = await Promise.all(
//          workPlan.workPlanStages.map(async (stage) => {

//             const normalizedTypes = await Promise.all(
//                stage.workStageTypes.map(async (type) => {


//                   const fullMachinery = await fetchList(type.specialMachinery);
//                   const fullSafety = await fetchList(type.safetyMeasuresList);


//                   const normalizedSubtypes = await Promise.all(
//                      type.childsWorkStageType?.map(async (subtype) => {
//                         const subMachinery = await fetchList(subtype.specialMachinery);
//                         const subSafety = await fetchList(subtype.safetyMeasuresList);

//                         return {
//                            ...subtype,
//                            specialMachinery: subMachinery,
//                            safetyMeasuresList: subSafety,
//                         };
//                      }) || []
//                   );

//                   return {
//                      ...type,
//                      specialMachinery: fullMachinery,
//                      safetyMeasuresList: fullSafety,
//                      childsWorkStageType: normalizedSubtypes
//                   };
//                })
//             );

//             return {
//                ...stage,
//                workStageTypes: normalizedTypes
//             };
//          })
//       );

//       return {
//          data: {
//             ...workPlan,
//             workPlanStages: normalizedStages
//          }
//       };

//    } catch (e) {
//       console.log("LoaderWorkPlanUpdate error:", e);
//       throw e;
//    }
// }

const item = []

//перероблений лодер з нормалайзом машин,межурес і дочірніх типів(1)
export async function LoaderWorkPlanUpdate({ params }) {
   const id = params.pid;
   let loadedGraf = null
   if (!id) return { data: null };

   try {
      // 1. Основний план
      const response = await AxiosInstance.get(`${urlApi}/${id}`, header);
      const workPlan = response.data;


      //1.5 Підгружаєм ворк граф(поки лишаєм цю версію)
      try {

         loadedGraf = await AxiosInstance.get(
            `/work_graphs?workPlans.id=${id}`, // актуальний ендпоінт
            header
         );
         console.log('loadedGraph', loadedGraf)
         // workPlanStages = stagesResponse.data || [];
      } catch (e) {
         console.warn("Не вдалось підгрузити workPlanStages:", e);
         // workPlanStages = [];
      }


      // 1.5 Підгружаєм ворк граф з його стадіями та WorkPlans(на потім,иможливо знадобиться)
      // try {
      //    // Спочатку отримуєм сам граф по фільтру workPlans.id
      //    const graphResponse = await AxiosInstance.get(
      //       `/work_graphs?workPlans.id=${id}`,
      //       header
      //    );

      //    // Беремо перший елемент з hydra:member, якщо він є
      //    const graphData = graphResponse.data?.[0]
      //       // ?.['hydra:member']?.[0] 
      //       || null;
      //    console.log('graphData', graphData)
      //    if (graphData) {
      //       // Параллельно підгружаєм workGraphStages и workPlans по фільтру workGraph.id
      //       const [stagesResponse, plansResponse] = await Promise.all([
      //          AxiosInstance.get(`/work_graph_stages?workGraph.id=${graphData.id}&pagination=false`, header),
      //          AxiosInstance.get(`/work_plans?workGraph.id=${graphData.id}&pagination=false`, header)
      //       ]);

      //       loadedGraf = {
      //          ...graphData,
      //          workGraphStages: stagesResponse.data?.[0]
      //             // ['hydra:member']
      //             || [],
      //          workPlans: plansResponse.data?.[0]
      //             // ['hydra:member']
      //             || []
      //       };
      //    }

      //    console.log('loadedGraph', loadedGraf);

      // } catch (e) {
      //    console.warn("Не вдалось підгрузити workGraph та його дані:", e);
      //    loadedGraf = null;
      // }




      // 2. Підгрузка стадій ворк-плана по його ID
      let workPlanStages = [];
      try {
         const stagesResponse = await AxiosInstance.get(
            `${urlApi1}?workPlan.id=${id}&pagination=false`, // актуальний ендпоінт
            header
         );
         workPlanStages = stagesResponse.data || [];
      } catch (e) {
         console.warn("Не вдалось підгрузити workPlanStages:", e);
         workPlanStages = [];
      }

      // 3. Функція для підгрузки списків (машини та ОП)
      //версія один з умовами
      const fetchList = async (items) => {
         if (!items) return [];

         // приводимо до масиву
         const list = Array.isArray(items) ? items : [items];

         const requests = list.map(async (item) => {

            //  якщо стрінг — робимо запит
            if (typeof item === "string") {
               const cleanUri = item.replace(/^\/api/, "");
               const res = await AxiosInstance.get(cleanUri, header);
               return res.data;
            }

            //  якщо уже объект — просто повертаєм
            if (typeof item === "object" && item !== null) {
               return item;
            }

            return null;
         });

         const result = await Promise.all(requests);

         return result.filter(Boolean);
      };




      // 4. Нормалайз стадій і типів
      const normalizedStages = await Promise.all(
         workPlanStages.map(async (stage) => {
            const normalizedTypes = await Promise.all(
               stage.workStageTypes?.map(async (type) => {
                  const fullMachinery = await fetchList(type.specialMachinery);
                  const fullSafety = await fetchList(type.safetyMeasuresList);
                  const fullWorkers = await fetchList(type.workStageTypeWorkers);//додано

                  const normalizedSubtypes = await Promise.all(
                     type.childsWorkStageType?.map(async (subtype) => {
                        const subMachinery = await fetchList(subtype.specialMachinery);
                        const subSafety = await fetchList(subtype.safetyMeasuresList);
                        const subWorkers = await fetchList(subtype.workStageTypeWorkers);//додано

                        return {
                           ...subtype,
                           specialMachinery: subMachinery,
                           safetyMeasuresList: subSafety,
                           workStageTypeWorkers: subWorkers,//додано
                        };
                     }) || []
                  );

                  return {
                     ...type,
                     specialMachinery: fullMachinery,
                     safetyMeasuresList: fullSafety,
                     childsWorkStageType: normalizedSubtypes,
                     workStageTypeWorkers: fullWorkers, //додано
                  };
               }) || []
            );

            return {
               ...stage,
               workStageTypes: normalizedTypes,
            };
         })
      );

      // 5. Повертаємо об'єкт з нормалізованими даними
      return {
         data: {
            ...workPlan,
            workPlanStages: normalizedStages,
            workGraph: loadedGraf?.data?.[0] || null
            //Оновлений варіант після зміни 1.5
            // workGraph: loadedGraf || null
         },
      };
   } catch (e) {
      console.error("LoaderWorkPlanUpdate error:", e);
      throw e;
   }
}





export default function WorkPlanTable() {
   // дані для оновлення
   const { data } = useLoaderData() || {}
   // console.log('data', data)
   const [userId, setUserId] = useState(false)
   const [dataState, setDataState] = useState(data != undefined ? data : null)
   // console.log('dataState', dataState);
   const [agreementsOptions, setAgreementsOptions] = useState([])
   //опціі інженерів
   const [engineers, setEngineers] = useState([])
   //опціі графіків
   const [graphs, setGraphs] = useState([])
   //для вибору партнера
   const [selectedOptionPartner, setSelectedOptionPartner] = useState('')
   //для вибору factory
   const [selectedOptionFactories, setSelectedOptionFactories] = useState('')
   //для вибору інженера
   const [selectedOptionEngineers, setSelectedOptionEngineers] = useState('')
   //для вибору договору
   const [selectedAgreement, setSelectedAgreement] = useState('')
   //для вибору графа
   const [selectedGraph, setSelectedGraph] = useState('')
   //для опису
   const [description, setDescription] = useState(data !== null ? data?.description : '')
   //для селекту зі списком етапів
   const [selectedOptionStage, setSelectedOptionStage] = useState('')
   const [selectedOptionType, setSelectedOptionType] = useState('')

   const [planStages, setPlanStages] = useState(data != undefined ? data?.workPlanStages : [])
   //повний список статичних етапів,не для селекту
   const [planStagesStaticList, setPlanStagesStaticList] = useState([])
   const [typeSelections, setTypeSelections] = useState({});

   //стани для дат для старту
   const [dateStart, setDateStart] = useState({})

   //стани для дат для кінця типу
   const [dateEnd, setDateEnd] = useState({})

   //стани для вибраних працівників
   const [workerSelections, setWorkerSelections] = useState({});

   //стани для вибраних працівників
   const [machineriesSelections, setMachineriesSelections] = useState({});

   //стани для заходів з ОП 
   const [measuresSelections, setMeasuresSelections] = useState({})

   const [subTypes, setSubTypes] = useState([]);

   //стан для імені нового підтипу
   const [newSubTypeName, setNewSubTypeName] = useState({});

   //стан для відкривання приховування блоку субтипів
   const [subtypeLogicBlock, setSubtypeLogicBlock] = useState({})


   //стан для workPlan
   const [workPlan, setWorkPlan] = useState(data ? data : {})
   //стан для workGraf
   const [workGraph, setWorkGraph] = useState({})

   //стан для поля з ынженером по айд
   const [engineer, setEngineer] = useState({})

   //вибраний графік робіт


   //статус ОП
   const [opStatus, setOpStatus] = useState(dataState?.isComfirmedOp || false)
   //статус інженера
   const [ingeneerStatus, setIngeneerStatus] = useState(dataState?.isComfirmedEngineer || false)
   //статус будівельника
   const [constructorStatus, setConstructorStatus] = useState(dataState?.isComfirmedConstructor || false)

   //стан для коменту
   const [coment, setComent] = useState({})

   //стан всих працівників контрагента на якого створено план
   const [workers, setWorkers] = useState([])
   //стан для workers Profesion list-список існуючих робіт
   const [workerProfessionsList, setWorkerProfessionsList] = useState([])
   //стан для селекту професій воркера
   const [workersForSelect, setWorkersForSelect] = useState([])
   const [isLoadingForSelect, setIsLoadingForSelect] = useState(false)

   //дефолтні стани для деяких асинк селектів
   //стан для дефолтного стану асинк селекту 
   const [localTypeStages, setLocalTypeStages] = useState([])
   //стан для дефолтного стану асинк селекту 
   const [localStagesList, setLocalStagesList] = useState([])
   const [localMeasuresList, setLocalMeasuresList] = useState([])
   const [localWorkersList, setLocalWorkersList] = useState([])
   const [localMachines, setLocalMachines] = useState([])
   //стан підгрузки для лодера
   const [isLoading, setIsLoading] = useState(false)
   //стан воркер профешинс для працівників контрагента
   const [workerProfessionsAll, setWorkerProfessionsAll] = useState([])
   //помилки для воркера,для селекта
   const [professionErrors, setProfessionErrors] = useState({})
   //стан для дозволу редагування рядків
   const [isDateEditingAllowed, setIsDateEditingAllowed] = useState(dataState?.dateEditingAllowed ?? false)


   const { weekStart, weekEnd } = getNextWeekInterval();



   // При зміні planStages оновлюємо стейт дат
   // useEffect(() => {
   //    if (planStages?.length) {
   //       const startDates = {};
   //       const endDates = {};

   //       planStages.forEach(stage => {
   //          stage.workStageTypes?.forEach(type => {
   //             if (type.dateStart) {
   //                startDates[type.id] = dayjs(type.dateStart).format('YYYY-MM-DD'); // формат для input type="date"
   //             }
   //             if (type.dateEnd) {
   //                endDates[type.id] = dayjs(type.dateEnd).format('YYYY-MM-DD');
   //             }
   //          });
   //       });

   //       setDateStart(startDates);
   //       setDateEnd(endDates);
   //    }
   // }, [planStages, subtypeLogicBlock]);

   useEffect(() => {
      AxiosInstance.get(`/work_types_lists?pagination=false`).then(response => {
         setLocalTypeStages(response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || []
         )
      })

      AxiosInstance.get(`/work_stages_lists?pagination=false`).then(response => {
         setPlanStagesStaticList(response.data?.['hydra:member'])
         setLocalStagesList(response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || []
         )
      })

      AxiosInstance.get(`/safety_measures_lists?pagination=false`).then(response => {
         setLocalMeasuresList(response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || []
         )
      })
      AxiosInstance.get(`/workers?accountWorkers.account.id=${dataState?.account.id}&pagination=false`).then(response => {
         const workersData = response.data?.['hydra:member']
         setWorkers(response.data?.['hydra:member'])
         setLocalWorkersList(response.data?.['hydra:member']?.map((result) => ({
            label: result.fullName,
            value: result.id,
         })) || []
         )
         console.log('workersData', workersData)
         //запит за професіями воркерів сет їх в workerProfesionsAll
         //дуже багато запитів за професіями,якщо багато воркерів.Треба брати дані з воркера
         // if (workersData.length > 0 && dataState) {
         //    (async () => {
         //       try {
         //          // Запити за професіями всіх воркерів паралельно
         //          const professionRequests = workersData.map(worker =>
         //             AxiosInstance.get(`/worker_proffessions?worker.id=${worker.id}&pagination=false`)
         //          );

         //          const professionsResponses = await Promise.all(professionRequests);


         //          const professionsMap = {};
         //          professionsResponses.forEach((res, index) => {
         //             professionsMap[workersData[index].id] = res.data?.['hydra:member'] || [];
         //          });


         //          setWorkerProfessionsAll(professionsMap);
         //       } catch (err) {
         //          console.error('Помилка при завантаженні професій працівників:', err);
         //          toast.error('Не вдалося підвантажити професії працівників');
         //       }
         //    })();
         // }
         //кінець запиту за професіями

         //блок замінено .Дані беруться з воркера
         const professionsMap = {};
         workersData.forEach(worker => {
            professionsMap[worker.id] = worker.workerProffessions || [];
         });
         setWorkerProfessionsAll(professionsMap);


      })
      AxiosInstance.get(`/special_machineries`).then(response => {
         setLocalMachines(response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || []
         )
      })




      // const stages = response.data?.['hydra:member']?.map((result) => ({
      //    label: result.name,
      //    value: result.id,
      // })) || [];

      // setAgreementsOptions(stages);
      // console.log('stages', stages)


   }, [])

   //оновлена версія для субтипів
   useEffect(() => {
      if (planStages?.length) {
         const startDates = {};
         const endDates = {};

         planStages.forEach(stage => {
            stage.workStageTypes?.forEach(type => {
               // Даты самого типа
               if (type.dateStart) startDates[type.id] = dayjs(type.dateStart).format('YYYY-MM-DD');
               if (type.dateEnd) endDates[type.id] = dayjs(type.dateEnd).format('YYYY-MM-DD');

               // Даты подтипов (childsWorkStageType)
               type.childsWorkStageType?.forEach(subtype => {
                  if (subtype.dateStart) startDates[subtype.id] = dayjs(subtype.dateStart).format('YYYY-MM-DD');
                  if (subtype.dateEnd) endDates[subtype.id] = dayjs(subtype.dateEnd).format('YYYY-MM-DD');

                  // Если есть еще более глубокие уровни, тоже можно добавить:
                  // subtype.subtypes?.forEach(deeper => { ... })
               });
            });
         });

         setDateStart(startDates);
         setDateEnd(endDates);
      }
   }, [planStages, subtypeLogicBlock]);



   const navigate = useNavigate()
   //хендлери заглушки для дозволу редагування дат


   // const handleAllowDateEditing = () => setIsDateEditingAllowed(true)
   //хендлер для дозволу змінювати дати в любому інтервалі
   const handleAllowDateEditing = async () => {
      try {
         await AxiosInstance.patch(`/work_plans/${dataState.id}`, { dateEditingAllowed: true });
         setIsDateEditingAllowed(true);
         setWorkPlan(prev => ({ ...prev, dateEditingAllowed: true }));
      } catch (error) {
         console.error('Помилка при дозволі редагування дат:', error);
         toast.error('Не вдалося дозволити редагування дат');
      }
   }
   //хендлер для заборони змінювати дати в любому інтервалі
   const handleDisallowDateEditing = async () => {
      try {
         await AxiosInstance.patch(`/work_plans/${dataState.id}`, { dateEditingAllowed: false });
         setIsDateEditingAllowed(false);
         setWorkPlan(prev => ({ ...prev, dateEditingAllowed: false }));
      } catch (error) {
         console.error('Помилка при забороні редагування дат:', error);
         toast.error('Не вдалося заборонити редагування дат');
      }
   }



   // const handleDisallowDateEditing = () => setIsDateEditingAllowed(false)



   // Функція для зміни факторі
   const handleChangeFactories = (select) => {
      setSelectedOptionFactories(select)
   }

   //Функція для зміни інженера
   const handleChangeEngineers = (select) => {
      console.log(select)
      setSelectedOptionEngineers(select)
   }

   const handleChangeAgreement = (select) => {
      setSelectedAgreement(select)
      // loadOptionsEngineers(select)
   }

   //функція для зміни графіка
   const handleChangeGraph = (select) => {

      console.log(select)
      setSelectedGraph(select)
      getGraph(select)

      setSelectedOptionEngineers({ label: workGraph.engineer?.name, value: workGraph.engineer?.id })
      // loadOptionsEngineers(select)
   }


   // при зміні опції підрядника
   const handleChangePartner = (select) => {
      setSelectedOptionPartner(select)
      setSelectedAgreement('')

   }

   //при виборі етапу
   const handleChangeStage = (select) => {
      setSelectedOptionStage(select)
   }

   //для зміни типу в селекті
   const handleChangeType = (rowId, select) => {
      setTypeSelections(prev => ({
         ...prev,
         [rowId]: select
      }))
   }

   //для зміни часу dateStart
   const handleChangeTimeStart = async (typeId, select) => {
      setDateStart(prev => ({
         ...prev,
         [typeId]: select
      }))
      //створення дати початку в UTC 8:00
      // const utcDate = dayjs(select).utc().format();
      const utcDate = dayjs(select).format('YYYY-MM-DD') + 'T08:00:00Z';
      try {
         await AxiosInstance.put(`${urlApi2}/${typeId}`, { dateStart: utcDate }, header);
         updateWorkPlan(dataState.id)
      } catch (error) {
         console.error('Помилка при оновленні дати початку:', error);
         toast.error('Не вдалося оновити дату початку');
      }
   }

   //для зміни часу dateEnd
   const handleChangeTimeEnd = async (typeId, select) => {

      setDateEnd(prev => ({
         ...prev,
         [typeId]: select
      }))
      const endOfDayLocal = dayjs(select).endOf('day');

      //дата кінця на utc 18:00
      // const utcDate = endOfDayLocal.utc().format();
      const utcDate = dayjs(select).format('YYYY-MM-DD') + 'T18:00:00Z';

      try {
         await AxiosInstance.put(`${urlApi2}/${typeId}`, { dateEnd: utcDate }, header);
         updateWorkPlan(dataState.id)
      } catch (error) {
         console.error('Помилка при оновленні дати кінця:', error);
         toast.error('Не вдалося оновити дату кінця');
      }

   }


   // const [selectedStageId, setSelectedStageId] = useState(stages[0].id);
   const [rows, setRows] = useState([]);
   const [counter, setCounter] = useState(1);
   // const [workerSelections, setWorkerSelections] = useState({});


   // Заповнити Id користувача
   useEffect(() => {
      if (user_data != null) {
         let data = JSON.parse(user_data)
         setUserId(data.id)
      }
   }, [user_data])

   // функція для оновлення ворк план стара версія
   // async function updateWorkPlan(id) {
   //    try {
   //       const response = await AxiosInstance.get(`${urlApi}/${id}`, header);
   //       if (response.status === 200) {
   //          console.log(' Оновлений Work Plan отримано:', response.data);
   //          setPlanStages(response.data?.workPlanStages)
   //          return response.data;
   //       } else {
   //          // console.warn(' Не вдалося отримати оновлений Work Plan, статус:', response.status);
   //          return null;
   //       }
   //    } catch (error) {
   //       // console.error(' Помилка при отриманні оновленого Work Plan:', error);
   //       return null;
   //    }
   // }


   //Оновлений ворк план для підгрузки машин і сафеті межурес з childWorkStageTypes(не робить)
   // async function updateWorkPlan(id) {
   //    try {
   //       // 1. Отримуєм базовый Work Plan
   //       const response = await AxiosInstance.get(`${urlApi}/${id}`, header);
   //       if (response.status !== 200) return null;

   //       const workPlan = response.data;

   //       // 2. Функція підгрузки сутностей по URI
   //       const fetchList = async (uris) => {
   //          if (!uris || uris.length === 0) return [];

   //          const requests = uris.map(uri => {
   //             const cleanUri = uri.replace(/^\/api/, '');
   //             return AxiosInstance.get(cleanUri, header).then(res => res.data);
   //          });

   //          return Promise.all(requests);
   //       };

   //       // 3. Обробляєм рівні
   //       const normalizedStages = await Promise.all(
   //          workPlan.workPlanStages.map(async (stage) => {

   //             const normalizedTypes = await Promise.all(
   //                stage.workStageTypes.map(async (type) => {

   //                   // отримуєм спецтехніку і міри безпеки для типу
   //                   const fullMachinery = await fetchList(type.specialMachinery);
   //                   const fullSafety = await fetchList(type.safetyMeasuresList);

   //                   // підтипи
   //                   const normalizedSubtypes = await Promise.all(
   //                      type.childsWorkStageType?.map(async (subtype) => {
   //                         const subMachinery = await fetchList(subtype.specialMachinery);
   //                         const subSafety = await fetchList(subtype.safetyMeasuresList);

   //                         return {
   //                            ...subtype,
   //                            specialMachinery: subMachinery,
   //                            safetyMeasuresList: subSafety,
   //                         };
   //                      }) || []
   //                   );

   //                   return {
   //                      ...type,
   //                      specialMachinery: fullMachinery,
   //                      safetyMeasuresList: fullSafety,
   //                      childsWorkStageType: normalizedSubtypes
   //                   };
   //                })
   //             );

   //             return {
   //                ...stage,
   //                workStageTypes: normalizedTypes,
   //             };
   //          })
   //       );

   //       const updatedWorkPlan = {
   //          ...workPlan,
   //          workPlanStages: normalizedStages,
   //       };

   //       // оновлюєм локальний стейт
   //       setPlanStages(updatedWorkPlan.workPlanStages);

   //       // console.log('Оновлений Work Plan (підвантажений):', updatedWorkPlan);

   //       return updatedWorkPlan;

   //    } catch (error) {
   //       console.error('Помилка при отриманні оновленого Work Plan:', error);
   //       return null;
   //    }
   // }


   //(2)Після прибирання полів з воркплан
   async function updateWorkPlan(id) {
      console.log('funcId', id)
      if (!id) return { data: null };

      try {
         // 1. Основний план
         const response = await AxiosInstance.get(`${urlApi}/${id}`, header);
         const workPlan = response.data;

         // 2. Підгрузка стадій ворк-плана по його ID
         let workPlanStages = [];
         try {
            const stagesResponse = await AxiosInstance.get(
               `${urlApi1}?workPlan.id=${id}&pagination=false`,
               header
            );
            workPlanStages = stagesResponse.data || [];
         } catch (e) {
            console.warn("Не вдалось підгрузити workPlanStages:", e);
            workPlanStages = [];
         }

         // 3. Функція для підгрузки списків (машини та ОП)
         //версія один з умовами
         const fetchList = async (items) => {
            if (!items) return [];
            const list = Array.isArray(items) ? items : [items];
            const requests = list.map(async (item) => {
               if (typeof item === "string") {
                  const cleanUri = item.replace(/^\/api/, "");
                  const res = await AxiosInstance.get(cleanUri, header);
                  return res.data;
               }
               if (typeof item === "object" && item !== null) return item;
               return null;
            });
            const result = await Promise.all(requests);
            return result.filter(Boolean);
         };



         // 4. Нормалізація стадій і типів
         const normalizedStages = await Promise.all(
            workPlanStages.map(async (stage) => {
               const normalizedTypes = await Promise.all(
                  stage.workStageTypes?.map(async (type) => {
                     const fullMachinery = await fetchList(type.specialMachinery);
                     const fullSafety = await fetchList(type.safetyMeasuresList);
                     const fullWorkers = await fetchList(type.workStageTypeWorkers);

                     const normalizedSubtypes = await Promise.all(
                        type.childsWorkStageType?.map(async (subtype) => {
                           const subMachinery = await fetchList(subtype.specialMachinery);
                           const subSafety = await fetchList(subtype.safetyMeasuresList);
                           const subWorkers = await fetchList(subtype.workStageTypeWorkers);

                           return {
                              ...subtype,
                              specialMachinery: subMachinery,
                              safetyMeasuresList: subSafety,
                              workStageTypeWorkers: subWorkers,
                           };
                        }) || []
                     );

                     return {
                        ...type,
                        specialMachinery: fullMachinery,
                        safetyMeasuresList: fullSafety,
                        childsWorkStageType: normalizedSubtypes,
                        workStageTypeWorkers: fullWorkers,
                     };
                  }) || []
               );

               return {
                  ...stage,
                  workStageTypes: normalizedTypes,
               };
            })
         );

         // 5. Оновлюємо локальний стейт
         setPlanStages(normalizedStages);

         // 6. Повертаємо об'єкт з нормалізованими даними
         return {
            data: {
               ...workPlan,
               workPlanStages: normalizedStages,
            },
         };
      } catch (e) {
         console.error("updateWorkPlan error:", e);
         return null;
      }
   }





   // додавання етапу
   const handleAddStage = async () => {
      // const stageObj = stages.find((s) => s.id === selectedStageId);
      // setRows([...rows, { id: counter, stage: stageObj.stage, types: [] }]);
      // setCounter(counter + 1);

      const data_response = {
         name: selectedOptionStage.label,
         // description: string,
         dateEntered: dayjs().toISOString(),
         workPlan: `/api/work_plans/${dataState.id}`,
         workStagesList: `/api/work_stages_lists/${selectedOptionStage.value}`,
      }
      // console.log('data_response', data_response)
      //

      // тут додати перевірку чи є такий етап
      const exists = planStages.some(elem => {
         const existingStageId = elem.workStagesList.split('/').pop();

         return Number(existingStageId) === Number(selectedOptionStage.value);
      });

      if (exists) {
         toast.error('Такий етап вже створено');
         return;
      }


      //перевірка чи є такий етап в іншому інтервалі графіка
      // if (dataState.workGraph) {

      //    try {
      //       const response = await AxiosInstance.get(`/work_graphs/${dataState.workGraph.id}`);
      //       const graph = response.data;

      //       console.log('response', response);
      //       console.log('graph response', graph);

      //       const stageExistsInGraph = graph.workGraphStages.some(stage => {
      //          const stageId = stage.workStagesList.id;
      //          return Number(stageId) === Number(selectedOptionStage.value);
      //       });

      //       if (stageExistsInGraph) {
      //          toast.error('Такий етап вже створено в іншому інтервалі графіка');
      //          setSelectedOptionStage('')
      //          return;
      //       }

      //       // return graph;
      //    } catch (error) {
      //       console.error('Помилка при отриманні графа:', error);
      //       throw error;
      //    }

      // }


      const response = await AxiosInstance.post(`${urlApi1}`, data_response, header);
      console.log('response', response)

      if (response.status === 201) {
         // toast.success('Етап успішно створено');

         updateWorkPlan(dataState.id)
         setSelectedOptionStage('')

      } else {
         toast.error('Етап не створено');
      }
   };

   //Видалення етапу 
   const handleDeleteRow = async (rowId) => {
      try {
         // Видаляєм з локального стейта
         // setRows(prev => prev.filter(r => r.id !== rowId));

         const response = await AxiosInstance.delete(`${urlApi1}/${rowId}`, header);
         console.log('response', response);

         if (response.status === 204 || response.status === 200) {
            // toast.success('Етап успішно видалено');
            // setPlanStages(prev => prev.filter(r => r.id !== rowId));
            updateWorkPlan(dataState.id)
         } else {
            toast.error('Не вдалося видалити етап');
         }
      } catch (error) {
         // console.error('Помилка при видаленні етапу:', error);
         toast.error('Сталася помилка при видаленні етапу');
      }

   };

   //додавання звичайного типу без батька
   const handleAddType = async (rowId) => {

      //тут перевірка чи є такий тип в етапі
      const exists = planStages.find(elem => elem.id === rowId).workStageTypes.some(e => e.workTypesList.id === typeSelections[rowId].value)

      if (exists) {
         toast.error('Цей тип роботи вже доданий до етапу')
         return
      }

      ////////////////////
      // ================================
      //  Перевірка в скопійованому графі ,чи є в цьому етапі скопійованого графа такий тип
      //Можна буде закоментувати ,якщо буде непотрібна
      // ================================
      // if (dataState.workGraph) {
      //    try {
      //       // отримуємо граф
      //       const response = await AxiosInstance.get(`/work_graphs/${dataState.workGraph.id}`);
      //       const graph = response.data;
      //       // console.log('graphResponse', graph)

      //       // 1. знаходимо поточний WorkPlanStage (за rowId)
      //       const currentPlanStage = planStages.find(elem => elem.id === rowId);
      //       // console.log('currentPlanStage', currentPlanStage)

      //       if (!currentPlanStage) {
      //          toast.error('Не знайдено етапу для перевірки');
      //          return;
      //       }

      //       // 2. отримуємо id workStagesList для цього етапу(в currentPlanStage.workStagesList знаходиться iri )
      //       // const stageListId = currentPlanStage.workStagesList.id;
      //       const stageListId = getIdFromIri(currentPlanStage.workStagesList)
      //       // console.log('stagesListId', stageListId)

      //       // 3. шукаємо відповідний етап у скопійованому графі
      //       const copiedStage = graph.workGraphStages.find(
      //          st => Number(st.workStagesList.id) === Number(stageListId)
      //       );
      //       // console.log('copiedStage', copiedStage)

      //       if (copiedStage) {
      //          // 4. перевіряємо типи
      //          const typeExistsInCopiedGraph = copiedStage.workGraphTypes?.some(
      //             t => Number(t.workTypeList.id) === Number(typeSelections[rowId].value)
      //          );
      //          // console.log('typeExistsInCopiedGraph', typeExistsInCopiedGraph)

      //          if (typeExistsInCopiedGraph) {
      //             toast.error('Цей тип вже існує в іншому інтервалі цього етапу скопійованого графіка');
      //             return;
      //          }
      //       }

      //    } catch (error) {
      //       console.error('Помилка при перевірці графа:', error);
      //    }
      // }
      // ================================


      /////////////////////

      const data_response = {
         name: typeSelections[rowId].label,
         // description: string,
         dateEntered: dayjs().toISOString(),
         workPlanStage: `/api/work_plan_stages/${rowId}`,
         workTypesList: `/api/work_types_lists/${typeSelections[rowId].value}`,

      }
      // console.log('data_response', data_response)
      //
      const response = await AxiosInstance.post(`${urlApi2}`, data_response, header);
      // console.log('response', response)

      if (response.status === 201) {
         // toast.success('Етап успішно створено');
         // setPlanStages(prev => [...prev, response.data])
         updateWorkPlan(dataState.id)
         setSelectedOptionStage('')

      } else {
         toast.error('Етап не створено');
      }
   };

   //додавання субтипу з батьком 
   const handleAddSubType = async (parentTypeId) => {

      const name = newSubTypeName[parentTypeId];
      if (!name) {
         toast.error('Введіть назву підтипу');
         return;
      }

      try {

         const data = {
            parent: `/api/work_stage_types/${parentTypeId}`,
            description: name,    // Назва підтипа
            dateEntered: dayjs().toISOString(),
            workPlan: `/api/work_plans/${dataState.id}`
         };


         const response = await AxiosInstance.post(`${urlApi2}`, data
            , header
         );

         if (response.status === 201) {
            // toast.success('Підтип успішно додано');
            updateWorkPlan(dataState.id)
            setSelectedOptionStage('')

            // setSubTypes((prev) => ({
            //    ...prev,
            //    [parentTypeId]: [...(prev[parentTypeId] || []), response.data],
            // }));


            setNewSubTypeName((prev) => ({ ...prev, [parentTypeId]: '' }));
         } else {
            toast.error('Не вдалося додати підтип');
         }
      } catch (error) {
         console.error(error);
         toast.error('Сталася помилка при додаванні підтипу');
      }
   };






   //видалення типу
   const handleDeleteType = async (rowId, typeId) => {
      // setRows((prev) =>
      //    prev.map((row) =>
      //       row.id === rowId
      //          ? { ...row, types: row.types.filter((type) => type.id !== typeId) }
      //          : row
      //    )
      // );

      try {
         // Видаляєм з локального стейта
         // setRows(prev => prev.filter(r => r.id !== rowId));

         const response = await AxiosInstance.delete(`${urlApi2}/${typeId}`, header);
         console.log('response', response);

         if (response.status === 204 || response.status === 200) {
            // toast.success('Етап успішно видалено');
            // setPlanStages(prev => prev.filter(r => r.id !== rowId));
            updateWorkPlan(dataState.id)
         } else {
            toast.error('Не вдалося видалити етап');
         }
      } catch (error) {
         // console.error('Помилка при видаленні етапу:', error);
         toast.error('Сталася помилка при видаленні етапу');
      }
   };



   //Додавання працівника 
   const handleAddWorker = async (rowId, typeId) => {
      const selectedWorker = workerSelections[typeId];
      if (!selectedWorker) return;


      //тут має бути перевірка чи доданий  такий воркер до типу
      const typeResponse = await AxiosInstance.get(`${urlApi2}/${typeId}`, header);
      console.log('typeResponse', typeResponse)
      console.log('selectedWorker', selectedWorker)

      if (typeResponse.status === 200) {
         // toast.success('Етап успішно створено');
         // updateWorkPlan(dataState.id)
         // setWorkerSelections(prev => ({ ...prev, [typeId]: null }));
         const exist = typeResponse.data.workStageTypeWorkers.find(w => w.worker.id === selectedWorker.value)
         console.log('exist', exist)
         if (exist) {
            toast.error('Даний працівник вже доданий до роботи')
            setWorkerSelections(prev => ({ ...prev, [typeId]: null }));

            return
         }

      }


      //кінець перевірки


      const data_response = {
         worker: `/api/workers/${selectedWorker.value}`,
         // description: string,
         workStageType: `/api/work_stage_types/${typeId}`,
         dateEntered: dayjs().toISOString(),

      }
      // console.log('data_response', data_response)
      //
      const response = await AxiosInstance.post(`${urlApi3}`, data_response, header);
      console.log('response', response)

      if (response.status === 201) {
         // toast.success('Етап успішно створено');
         // setPlanStages(prev => [...prev, response.data])

         updateWorkPlan(dataState.id)
         setWorkerSelections(prev => ({ ...prev, [typeId]: null })); // очищаємо селект

      } else {
         toast.error('Працівника  не додано');
      }

   };

   //вибір і додавання професіі для працівника
   const handleSelectProfession = async (workerId, selectedProfession) => {
      if (!selectedProfession) return;

      const data_response = {
         workerProffessions: `/api/worker_proffessions/${selectedProfession.value}`,
      };

      try {
         const response = await AxiosInstance.put(
            `${urlApi3}/${workerId}`,
            data_response,
            header
         );

         if (response.status === 200 || response.status === 201) {
            // toast.success('Професія успішно додана');
            // setShowProfessionErrors(false)
            setProfessionErrors(prev => ({ ...prev, [workerId]: false }))
            updateWorkPlan(dataState.id);
         } else {
            toast.error('Не вдалося додати професію');
         }
      } catch (error) {
         console.error('Error adding profession', error);
         toast.error('Сталася помилка при додаванні професії');
      }
   };


   //видалення воркера
   const handleDeleteWorker = async (rowId, typeId, workerIdx) => {
      console.log('workerIdx', workerIdx)
      try {
         // Видаляєм з локального стейта
         // setRows(prev => prev.filter(r => r.id !== rowId));

         const response = await AxiosInstance.delete(`${urlApi3}/${workerIdx}`, header);
         console.log('response', response);
         updateWorkPlan(dataState.id)
      } catch (error) {
         // console.error('Помилка при видаленні етапу:', error);
         toast.error('Сталася помилка при видаленні працівника');
      }

   };


   const handleAddMachine = async (typeId, option) => {
      console.log('option', option)
      if (!option) return;


      try {
         // Робим запит на тип
         const getResponse = await AxiosInstance.get(`${urlApi2}/${typeId}`, header);
         if (getResponse.status !== 200) {
            toast.error('Не вдалося отримати тип');
            return;
         }

         const currentData = getResponse.data;
         const currentMachines = currentData.specialMachinery || [];
         // console.log('currentMachines', currentMachines)

         // //  створюєм масив ірі для спешл машинері
         // const updatedMachines = [...currentMachines.map(elem => elem['@id']), `/api/special_machineries/${option.value}`];
         const newId = `/api/special_machineries/${option.value}`;
         const updatedMachines = [
            ...currentMachines.map(elem => `/api/special_machineries/${elem.id}`),
         ];

         if (updatedMachines.includes(newId)) {
            toast.error('Дана техніка вже додана до цього типу роботи');
            setMachineriesSelections(prev => ({
               ...prev,
               [typeId]: null
            }));

            return;
         }

         if (!updatedMachines.includes(newId)) {
            updatedMachines.push(newId);
         }

         console.log('updatedMachines', updatedMachines)

         //   PUT з новим масивом
         const putResponse = await AxiosInstance.put(
            `${urlApi2}/${typeId}`,
            { specialMachinery: updatedMachines },
            header
         );

         console.log('putResponse', putResponse);

         if (putResponse.status === 200 || putResponse.status === 201) {

            setMachineriesSelections(prev => ({
               ...prev,
               [typeId]: null
            }));

            updateWorkPlan(dataState.id);
         } else {
            toast.error('Техніку не додано');
         }

      }
      catch (error) {
         console.error(error);
         toast.error('Сталася помилка при додаванні техніки');
      }
   };


   //видалення машини з типу
   const handleDeleteMachine = async (typeId, machineId) => {

      console.log('machineId', machineId)
      try {
         const getResponse = await AxiosInstance.get(`${urlApi2}/${typeId}`, header);

         if (getResponse.status !== 200) {
            toast.error('Не вдалося отримати тип');
            return;
         }

         const currentData = getResponse.data;
         const currentMachines = currentData.specialMachinery || [];
         console.log('currentMachines', currentMachines)
         // Прибираємо потрібний елемент
         const updatedMachines = currentMachines
            .filter(m => m.id !== machineId)
            .map(m => `/api/special_machineries/${m.id}`);
         console.log('updatedMachines', updatedMachines)


         const putResponse = await AxiosInstance.put(
            `${urlApi2}/${typeId}`,
            { specialMachinery: updatedMachines },
            header
         );

         if (putResponse.status === 200 || putResponse.status === 201) {
            updateWorkPlan(dataState.id);
         } else {
            toast.error('Техніку не видалено');
         }

      } catch (error) {
         console.error(error);
         toast.error('Сталася помилка при видаленні техніки');
      }
   };



   const handleAddMeasure = async (typeId, option) => {
      console.log('option', option);
      if (!option) return;

      try {

         const getResponse = await AxiosInstance.get(`${urlApi2}/${typeId}`, header);
         if (getResponse.status !== 200) {
            toast.error('Не вдалося отримати тип');
            return;
         }

         const currentData = getResponse.data;
         const currentMeasures = currentData.safetyMeasuresList || [];
         console.log('currentMeasures', currentMeasures);

         const newId = `/api/safety_measures_lists/${option.value}`;
         const updatedMeasures = [
            ...currentMeasures.map(elem => `/api/safety_measures_lists/${elem.id}`),
         ];



         if (updatedMeasures.includes(newId)) {
            toast.error('Даний захід вже доданий до типу роботи')
            setMeasuresSelections(prev => ({
               ...prev,
               [typeId]: null
            }));
            return
         }

         if (!updatedMeasures.includes(newId)) {
            updatedMeasures.push(newId);
         }

         console.log('updatedMeasures', updatedMeasures);


         const putResponse = await AxiosInstance.put(
            `${urlApi2}/${typeId}`,
            { safetyMeasuresList: updatedMeasures },
            header
         );

         // console.log('putResponse', putResponse);

         if (putResponse.status === 200 || putResponse.status === 201) {

            setMeasuresSelections(prev => ({
               ...prev,
               [typeId]: null
            }));

            updateWorkPlan(dataState.id);
         } else {
            toast.error('Заходи не додано');
         }

      } catch (error) {
         console.error(error);
         toast.error('Сталася помилка при додаванні заходу');
      }
   };





   const thStyle = { border: '1px solid #ccc', padding: '6px', textAlign: 'left', background: '#eee' };
   const tdStyle = { border: '1px solid #ccc', padding: '4px', verticalAlign: 'top' };

   // опціі для селекту контрагентів

   // завантаження опцій підрядників у форму
   const loadOptionsPartners = async (inputValue) => {
      console.log('loadOptionsPartners called with:', inputValue)
      if (role === 'ROLE_ADMIN') {
         console.log('контрагенти адміна')
         const accounts = await AxiosInstance.get(`/accounts?name=${inputValue}`
            // , header
         ).then((response) => {
            // console.log(31231323, response);
            return response.data?.['hydra:member'].map((result) => ({
               label: result.name,
               value: result.id,
            }))
         }).catch(e => console.log(e))
         return accounts
      } else {
         if (userId !== false) {
            // return await AxiosInstance.get(`/users/${userId}`, header).then((response) => {
            return await AxiosInstance.get(`/accounts?user.id=${userId}`
               // , header
            ).then((response) => {
               // console.log(31231323, response)
               // return response.data.accounts.map((result) => ({
               return response.data?.['hydra:member'].map((result) => ({
                  label: result.name,
                  value: result.id,
               }))
            })
         }
      }
   }

   // Завантажити список факторіс
   const loadOptionsFactory = async (inputValue) => {
      return await AxiosInstance.get(`/factories?name=${inputValue}`
         // , header
      ).then((response) => {
         // console.log('response get /factories', response)
         return response.data?.['hydra:member'].map((result) => ({
            label: result.name,
            value: result.id,
         }))
      })
   }

   //завантаження опцій для селекту інженерів
   // const loadOptionsEngineers = async (selectedFactory) => {

   //    return await AxiosInstance.get(`/engineers?factory=${selectedFactory.value}`
   //       // , header
   //    ).then((response) => {
   //       // console.log('res1', response);
   //       const engineers = response.data?.['hydra:member'].map((result) => ({
   //          label: result.name,
   //          value: result.id,
   //       }))
   //       // console.log('res2', engineersOptions);
   //       // console.log('selectedOptionEngineers before:', selectedOptionEngineers);
   //       setEngineers(engineers);
   //       // console.log('selectedOptionEngineers after:', selectedOptionEngineers);
   //       return engineers
   //    })
   // }
   const loadOptionsEngineers = async (selectedFactory) => {

      return await AxiosInstance.get(`/factories?name=${selectedFactory.label}`
         // , header
      ).then((response) => {
         console.log('res1', response);
         const engineers = response.data
            ?.['hydra:member'][0]
            .engineers
            .map((result) => ({
               label: result.name,
               value: result.id,
            }))
         // console.log('res2', engineersOptions);
         // console.log('selectedOptionEngineers before:', selectedOptionEngineers);
         setEngineers(engineers);
         // console.log('selectedOptionEngineers after:', selectedOptionEngineers);
         return engineers
      })
   }


   function getIdFromIri(iri) {
      if (!iri) return null;
      return iri.split('/').pop();
   }

   //функція для отримання інженера
   async function getEngineer() {


      if (!dataState.engineer) return
      const engineerId = getIdFromIri(dataState?.engineer)

      return await AxiosInstance.get(`/engineers/${engineerId}`
         // , header
      ).then((response) => {
         // console.log('res1', response);
         console.log('response', response)
         const engineer = response.data
         // ?.['hydra:member']
         // console.log('graf response', graph);
         // console.log('selectedOptionEngineers before:', selectedOptionEngineers);
         setEngineer(engineer);
         // console.log('selectedOptionEngineers after:', selectedOptionEngineers);
         return engineer
      })
   }




   //  завантаження опцій договорів для селекту залежно від вибраного акаунту заводу
   const loadOptionsAgreements = async (selectedAccount) => {

      return await AxiosInstance.get(`/agreements?account.id=${selectedAccount.value}`
         // , header
      ).then((response) => {
         // console.log('res1', response);
         const agreements = response.data?.['hydra:member'].map((result) => ({
            label: result.name,
            value: result.id,
         }))
         // console.log('res2', engineersOptions);
         // console.log('selectedOptionEngineers before:', selectedOptionEngineers);
         setAgreementsOptions(agreements);
         // console.log('selectedOptionEngineers after:', selectedOptionEngineers);
         return agreements
      })
   }
   //завантаження опцій для workGraf
   const loadOptionsGraphs = async (selectedAccount, selectedAgreement, selectedFactory) => {

      return await AxiosInstance.get(`/work_graphs?account.id=${selectedAccount.value}&agreement.id=${selectedAgreement.value}&factory.id=${selectedFactory.value}`
         // , header
      ).then((response) => {
         // console.log('res1', response);
         const graphs = response.data?.['hydra:member'].map((result) => ({
            label: result.id,
            value: result.id,
         }))
         // console.log('res2', engineersOptions);
         // console.log('selectedOptionEngineers before:', selectedOptionEngineers);
         setGraphs(graphs);
         // console.log('selectedOptionEngineers after:', selectedOptionEngineers);
         return graphs
      })
   }

   //запит за графіком при створенні плану робіт згідно графіка
   // async function getGraph(select) {
   //    return await AxiosInstance.get(`/work_graphs/${select.value}`
   //       // , header
   //    ).then((response) => {
   //       // console.log('res1', response);
   //       console.log('response', response)
   //       const graph = response.data
   //       // ?.['hydra:member']
   //       console.log('graf response', graph);
   //       // console.log('selectedOptionEngineers before:', selectedOptionEngineers);
   //       setWorkGraph(graph);
   //       // console.log('selectedOptionEngineers after:', selectedOptionEngineers);
   //       return graph
   //    })
   // }

   //оновлений getGraph з доданими до нього планами робіт і графстейджесами 
   async function getGraph(select) {
      try {
         const graphId = select.value;

         // 1. Запит за самим графом
         const graphPromise = AxiosInstance.get(`/work_graphs/${graphId}`);

         // 2. Запит за стадіями графа по фільтру workGraph.id
         const stagesPromise = AxiosInstance.get(`/work_graph_stages?workGraph.id=${graphId}&pagination=false`);

         // 3. Запит за  WorkPlans по фільтру workGraph.id
         const plansPromise = AxiosInstance.get(`/work_plans?workGraph.id=${graphId}&pagination=false`);

         // Чекаєм всі запити паралельно
         const [graphResponse, stagesResponse, plansResponse] = await Promise.all([
            graphPromise,
            stagesPromise,
            plansPromise
         ]);

         const fullGraph = {
            ...graphResponse.data,
            workGraphStages: stagesResponse.data?.['hydra:member'] || [],
            workPlans: plansResponse.data?.['hydra:member'] || []
         };

         setWorkGraph(fullGraph);
         //
         setSelectedOptionEngineers({ label: fullGraph.engineer.name, value: fullGraph.engineer.id })
         return fullGraph;

      } catch (error) {
         console.error('Помилка при отриманні графа:', error);
         return null;
      }
   }


   //Завантаження опцій для етапів
   const loadOptionsStages = async (inputValue) => {
      if (inputValue.length < 3) return []
      try {
         const response = await AxiosInstance.get(`/work_stages_lists?name=${inputValue}`);
         const stages = response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || [];

         // setAgreementsOptions(stages);
         // console.log('stages', stages)
         return stages;
      } catch (error) {
         console.error("Помилка при завантаженні етапів:", error);
         return [];
      }
   };

   //завантаження опцій для батьківських типів
   const loadOptionsTypes = async (inputValue) => {
      if (inputValue < 3) return []
      try {
         const response = await AxiosInstance.get(`/work_types_lists?name=${inputValue}`);
         const stages = response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || [];

         // setAgreementsOptions(stages);
         // console.log('stages', stages)
         return stages;
      } catch (error) {
         console.error("Помилка при завантаженні типів:", error);
         return [];
      }
   };

   //Завантаження списку працівників 
   const loadOptionsWorkers = async (inputValue) => {
      if (inputValue.length < 3) return []
      try {
         //перша версія з нерозгорнутими воркер профешнс
         const response = await AxiosInstance.get(`/workers?fullName=${inputValue}&accountWorkers.account.id=${dataState.account.id}&pagination=false`);
         const workers = response.data?.['hydra:member']?.map((result) => ({
            label: result.fullName,
            value: result.id,
         })) || [];

         setWorkers(response.data?.['hydra:member'])
         // console.log('workers', response.data?.['hydra:member'])
         return workers;


      } catch (error) {
         console.error("Помилка при завантаженні працівників:", error);
         return [];
      }
   };


   const allProfessionsList = async () => {
      // console.log('workers', workers)
      try {
         const response = await AxiosInstance.get(`/worker_proffession_lists?pagination=false`);
         const professions = response.data?.['hydra:member']
            // ?.map((result) => ({
            //    label: result.fullName,
            //    value: result.id,
            // })) 
            || [];


         setWorkerProfessionsList(response.data?.['hydra:member'])
         // setWorkers(response.data?.['hydra:member'])
         // console.log('workers', response.data?.['hydra:member'])


         return professions;
      } catch (error) {
         console.error("Помилка при завантаженні професій:", error);
         return [];
      }
   }



   //Завантаження списку техніки 


   const loadOptionsMachines = async (inputValue) => {
      if (inputValue.length < 3) return []
      try {
         const response = await AxiosInstance.get(`/special_machineries?name=${inputValue}`);
         const machines = response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || [];

         // setAgreementsOptions(stages);
         // console.log('workers', workers)
         return machines;
      } catch (error) {
         console.error("Помилка при завантаженні працівників:", error);
         return [];
      }
   };

   //завантаження списку заходів з ОП
   const loadOptionsMeasures = async (inputValue) => {
      if (inputValue.length < 3) return []
      try {
         const response = await AxiosInstance.get(`/safety_measures_lists?name=${inputValue}`);
         const measures = response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || [];

         // setAgreementsOptions(stages);
         // console.log('', workers)
         return measures;
      } catch (error) {
         console.error("Помилка при завантаженні заходів:", error);
         return []
      }
   };






   // Викликати ф-цію запиту за списком для отримання списку договорів
   useEffect(() => {
      // console.log('selectedOptionPartner', selectedOptionPartner);
      if (selectedOptionPartner !== '') {
         loadOptionsAgreements(selectedOptionPartner);
      }
   }, [selectedOptionPartner]);

   //викликати ф-цію для отримання інженерів по підрозділу
   useEffect(() => {
      // console.log('selectedOptionPartner', selectedOptionPartner);
      if (selectedOptionFactories !== '') {
         loadOptionsEngineers(selectedOptionFactories);
      }
   }, [selectedOptionFactories]);

   //викликати функцію для отримання списку графіків
   useEffect(() => {
      // console.log('selectedOptionPartner', selectedOptionPartner);
      if (selectedOptionFactories !== '' && selectedAgreement !== '' && selectedOptionPartner !== '') {
         loadOptionsGraphs(selectedOptionPartner, selectedAgreement, selectedOptionFactories);
      }
   }, [selectedOptionFactories, selectedAgreement, selectedOptionPartner]);


   // useEffect(() => {
   //    // allProfessionsList()

   //    if (workers.length > 0) {
   //       const preparedWorkers = [...workers].map((worker) => {
   //          const updatedProfessions = worker.workerProffessions?.map((wp) => {
   //             const listId = Number(wp.workerProffessionList.split('/').pop());
   //             console.log('listId', listId)
   //             // шукаєм объект професіі по id
   //             console.log('workerProfessionsList in effect', workerProfessionsList)
   //             // const listObj = workerProfessionsList.find((pl) => pl.id == listId);
   //             const listObj = workerProfessionsList.find((pl) => {
   //                console.log('pl.id', pl.id)
   //                console.log('listIdInFind', listId)
   //                return pl.id == listId;
   //             })

   //             console.log('listObj', listObj)
   //             return {
   //                ...wp,
   //                workerProffessionList: listObj || { id: listId, name: 'Невідомо' }
   //             };
   //          }) || [];
   //          console.log('updatedProffessions', updatedProfessions)
   //          return {
   //             ...worker,
   //             workerProffessions: updatedProfessions
   //          };
   //       });

   //       setWorkersForSelect(preparedWorkers)

   //    }
   // }, [workers, workerProfessionsList])

   //


   //для нормального логування на проді
   useEffect(() => {
      // console.log('workers', workers);
      // console.log('workerProfessionsList', workerProfessionsList);
      // console.log('Updating workersForSelect...');

      if (workers.length > 0 && workerProfessionsList.length > 0) {
         setIsLoadingForSelect(true)
         const preparedWorkers = workers.map((worker) => {
            // console.log('worker', worker);

            const updatedProfessions = worker.workerProffessions?.map((wp) => {

               //прибираємо і міняємо 
               // const listId = Number(wp.workerProffessionList.split('/').pop());
               // // console.log('listId', listId);

               // const listObj = workerProfessionsList.find((pl) => {
               //    // console.log('checking pl.id', pl.id, 'against listId', listId);
               //    return pl.id == listId;
               // });
               const listObj = typeof wp.workerProffessionList === 'object' && wp.workerProffessionList !== null
                  ? wp.workerProffessionList
                  : workerProfessionsList.find((pl) => pl.id == Number(wp.workerProffessionList.split('/').pop()));


               // console.log('listObj found', listObj);

               return {
                  ...wp,
                  workerProffessionList: listObj ||
                     // { id: listId, name: 'Невідомо' }
                     { id: null, name: 'Невідомо' }
               };
            }) || [];

            // console.log('updatedProfessions for worker', updatedProfessions);

            return {
               ...worker,
               workerProffessions: updatedProfessions
            };
         });

         // console.log('preparedWorkers', preparedWorkers);
         setWorkersForSelect(preparedWorkers);
         setIsLoadingForSelect(false)
      }
   }, [workers, workerProfessionsList?.length]);

   useEffect(() => {
      allProfessionsList()
      if (dataState?.engineer) {
         getEngineer()
      }

   }, [])

   // Функція для відправки даних
   const handleSubmit = async (event) => {
      event.preventDefault()

      try {
         if (dataState) {
            console.log('submit')
            const data_response = {
               description: description
            };

            const response = await AxiosInstance.put(`${urlApi}/${dataState.id}`, data_response, header);

            if (response.status === 200) {
               // popup.toastifySuccess(popupTextPutSuccess);
               // getData();
               setWorkPlan(prev => ({ ...prev, description }))
            } else {
               toast.error('Помилка при оновленні плану');
            }

         } else {
            const data_response = {
               account: `/api/accounts/${selectedOptionPartner.value}`,
               description: description,
               dateEntered: dayjs().toISOString(),
               agreement: `/api/agreements/${selectedAgreement.value}`,
               factory: `/api/factories/${selectedOptionFactories.value}`,
               status: 'new',
               engineer: `/api/engineers/${selectedOptionEngineers.value}`
            };

            const response = await AxiosInstance.post(`${urlApi}`, data_response, header);
            console.log('response', response)

            if (response.status === 201) {
               toast.success('План успішно створено');
               setSelectedOptionPartner('')
               setSelectedOptionFactories('')
               setSelectedAgreement('')
               setDescription('')
               navigate(urlRouter);


            } else {
               toast.error('План не створено');
            }
         }

      } catch (e) {
         toast.error('Сталася помилка при збереженні');
         console.error(e);
      }
   }


   //блок зміни статусів
   //БЛОК ЗМІНИ СТАТУСА ДОКУМЕНТА ДЛЯ АДМІНА

   //зміна статуса на підтверджено verified
   async function adminConfirmToSuccess(id) {
      try {
         await confirmAlert({
            title: 'Увага',
            message: 'Ви впевнені що хочете підтвердити інструмент ?',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => changeStatusToSuccess(id)
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }

   }

   async function changeStatusToSuccess(id) {
      const docData = {
         status: 'verified',
         // dateConfirm: new Date().toISOString(),
         // userComfirmDescription: coment[id] || ''
      }

      try {
         const response = await AxiosInstance.put(`${urlApi}/${id}`, docData, header);
         toast.success('План робіт підтверджено')
         setWorkPlan(response.data)

         // setComent(prev => {
         //    const newComent = { ...prev };
         //    delete newComent[id];
         //    return newComent;
         // })
         return response.data;
      } catch (error) {
         console.error('Помилка при зміні статуса:', error);
         throw error;
      }
   }

   //зміна статуса на rejected
   async function adminConfirmToRejected(id) {

      try {
         await confirmAlert({
            title: 'Увага',
            message: 'Ви впевнені що хочете відхилити План робіт ?',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => changeStatusToRejected(id)
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }

   }

   async function changeStatusToRejected(id) {
      const docData = {
         status: 'rejected',
         // userComfirmDescription: coment[id] || ''
         sendToVerifyTime: null
      }

      try {
         const response = await AxiosInstance.put(`${urlApi}/${id}`, docData, header);
         toast.success('План робіт відхилено')
         setWorkPlan(response.data)


         // 2. Формуємо масив запитів для кожного id зі стану coment
         const requests = Object.entries(coment).map(([typeId, commentValue]) =>
            AxiosInstance.put(`${urlApi2}/${typeId}`, { commentar: commentValue }, header)
         );

         // 3. Відправляємо всі запити паралельно
         await Promise.all(requests);

         //4.Очищуємо комент
         setComent({});

         //Оновлюєм ворк план
         updateWorkPlan(dataState.id)

         return response.data;
      } catch (error) {
         console.error('Помилка при зміні статуса:', error);
         throw error;
      }
   }

   //БЛОК ЗМІНИ СТАТУСА ДЛЯ ПАРТНЕРА
   //зміна статуса на send-to-verify +

   async function partnerConfirmToSendToVerify(id) {
      try {
         await confirmAlert({
            title: 'Увага',
            message: 'Ви впевнені що хочете відправити план робіт на перевірку ?',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => changeStatusToSendToVerify(id)
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }

   }
   //функція перевірки перед відправкою на перевірку sendToVerify
   const sendToVerifyCheck = () => {

      // 1. Чи є хоч один етап
      if (!planStages || planStages.length === 0) {
         toast.error('Створіть хоча б один етап і заповніть поля');
         return false;
      }

      // 2. Чи є хоча б один тип в етапах
      const hasAtLeastOneType = planStages.some(
         stage => stage.workStageTypes && stage.workStageTypes.length > 0
      );

      if (!hasAtLeastOneType) {
         toast.error('У Вас є незаповнені етапи,заповніть будьласка');
         return false;
      }
      //2.5 Чи є незаповнені дати
      const hasTypeWithoutDates = planStages.some(stage =>
         stage.workStageTypes?.some(type =>
            !type.dateStart || !type.dateEnd
         )
      );

      if (hasTypeWithoutDates) {
         toast.error('У Вас є типи з незаповненими датами, перевірте і заповніть будь ласка');
         return false;
      }

      // 3. Чи є тип без доданого працівника
      const hasTypeWithoutWorker = planStages.some(stage =>
         stage.workStageTypes?.some(type =>
            !type.workStageTypeWorkers || type.workStageTypeWorkers.length === 0
         )
      );

      if (hasTypeWithoutWorker) {
         toast.error('У Вас є типи без доданого працівника, додайте будь ласка');
         return false;
      }
      // 4. Чи є працівники без доданих професій
      const hasWorkerWithoutProfession = planStages.some(stage =>
         stage.workStageTypes?.some(type =>
            type.workStageTypeWorkers?.some(worker =>
               // додав перевірку також на позицію в воркері
               // !worker.workerProffessions || worker.workerProffessions === ''
               (!worker.workerProffessions || worker.workerProffessions === '') &&
               (!worker.worker?.position || worker.worker.position === '')
            )
         )
      );

      // if (hasWorkerWithoutProfession) {
      //    toast.error('У Вас в типах є працівники без доданих професій,перевірте і додайте будь ласка');
      //    return false;
      // }
      if (hasWorkerWithoutProfession) {
         toast.error('У Вас в типах є працівники без доданих професій,перевірте і додайте будь ласка');
         // setShowProfessionErrors(true);
         const errorIds = {};
         planStages.forEach(stage =>
            stage.workStageTypes?.forEach(type =>
               type.workStageTypeWorkers?.forEach(worker => {
                  if ((!worker.workerProffessions || worker.workerProffessions === '') &&
                     (!worker.worker?.position || worker.worker.position === ''))
                     errorIds[worker.id] = true;
               })
            )
         );
         setProfessionErrors(errorIds);
         //скрол до першої помилки
         const firstErrorId = Object.keys(errorIds)[0];
         if (firstErrorId) {
            setTimeout(() => {
               const el = document.getElementById(`worker-select-${firstErrorId}`);
               if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
         }
         //скрол до першої помилки

         return false;
      }


      // 5. Перевірка заходів з ОП
      const hasTypeWithoutSafetyMeasure = planStages.some(stage =>
         stage.workStageTypes?.some(type =>
            !type.safetyMeasuresList || type.safetyMeasuresList.length === 0
         )
      );

      if (hasTypeWithoutSafetyMeasure) {
         toast.error('Додайте хоча б один захід з ОП для кожного типу');
         return false;
      }
      //
      // перевірка підтипів на дати ,воркерів ,професіі і ОП
      // 6. Перевірка підтипів (childsWorkStageType)
      const hasSubTypeWithoutDates = planStages.some(stage =>
         stage.workStageTypes?.some(type =>
            type.childsWorkStageType?.some(subType =>
               !subType.dateStart || !subType.dateEnd
            )
         )
      );

      if (hasSubTypeWithoutDates) {
         toast.error('У Вас є підтипи з незаповненими датами, перевірте і заповніть будь ласка');
         return false;
      }

      const hasSubTypeWithoutWorker = planStages.some(stage =>
         stage.workStageTypes?.some(type =>
            type.childsWorkStageType?.some(subType =>
               !subType.workStageTypeWorkers || subType.workStageTypeWorkers.length === 0
            )
         )
      );

      if (hasSubTypeWithoutWorker) {
         toast.error('У Вас є підтипи без доданого працівника, додайте будь ласка');
         return false;
      }

      const hasSubWorkerWithoutProfession = planStages.some(stage =>
         stage.workStageTypes?.some(type =>
            type.childsWorkStageType?.some(subType =>
               subType.workStageTypeWorkers?.some(worker =>
                  // !worker.workerProffessions || worker.workerProffessions === ''
                  (!worker.workerProffessions || worker.workerProffessions === '') &&
                  (!worker.worker?.position || worker.worker.position === '')
               )
            )
         )
      );

      // if (hasSubWorkerWithoutProfession) {
      //    toast.error('У Вас є працівники в підтипах без доданих професій');
      //    return false;
      // }
      if (hasSubWorkerWithoutProfession) {
         toast.error('У Вас є працівники в підтипах без доданих професій');
         const errorIds = {};
         planStages.forEach(stage =>
            stage.workStageTypes?.forEach(type =>
               type.childsWorkStageType?.forEach(subtype =>
                  subtype.workStageTypeWorkers?.forEach(worker => {
                     if ((!worker.workerProffessions || worker.workerProffessions === '') &&
                        (!worker.worker?.position || worker.worker.position === ''))
                        errorIds[worker.id] = true;
                  })
               )
            )
         );
         setProfessionErrors(errorIds);
         //скрол до першої помилки
         const firstErrorId = Object.keys(errorIds)[0];
         if (firstErrorId) {
            setTimeout(() => {
               const el = document.getElementById(`worker-select-${firstErrorId}`);
               if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
         }
         //скрол до першої помилки
         return false;
      }


      const hasSubTypeWithoutSafetyMeasure = planStages.some(stage =>
         stage.workStageTypes?.some(type =>
            type.childsWorkStageType?.some(subType =>
               !subType.safetyMeasuresList || subType.safetyMeasuresList.length === 0
            )
         )
      );

      if (hasSubTypeWithoutSafetyMeasure) {
         toast.error('Додайте хоча б один захід з ОП для кожного підтипу');
         return false;
      }
      //кінець перевірки підтипів на дати ,воркерів ,професіі і ОП

      return true;
   };





   async function changeStatusToSendToVerify(id) {

      if (!sendToVerifyCheck()) return;

      const docData = {
         status: 'send-to-verify',
         sendToVerifyTime: dayjs().utc().format()
      }

      try {
         const response = await AxiosInstance.put(`${urlApi}/${id}`, docData, header);
         toast.success('План робіт відправлено на перевірку')
         // workerProfessionsList()
         console.log('respone.data', response.data)
         setWorkPlan(response.data)

         const coment = extractComments(planStages)

         // 2. Формуємо  массив запитів для кожного id зі стану coment
         const requests = Object.keys(coment).map((typeId) =>
            AxiosInstance.put(`${urlApi2}/${typeId}`, { commentar: '' }, header)
         );

         // 3. Відправляєм всі запити паралельно
         await Promise.all(requests);

         // 4. Очищуємо стан coment
         setComent({});

         //Оновлюєм ворк план
         updateWorkPlan(dataState.id)

         return response.data;
      } catch (error) {
         console.error('Помилка при зміні статуса:', error);
         throw error;
      }
   }

   //функція для діставання соментів з айдішками з планстейджес
   function extractComments(workPlanStages) {
      const result = {};

      const traverseTypes = (types) => {
         if (!types || types.length === 0) return;

         types.forEach(type => {
            // Якщо є commentar і він не пустий
            if (type.commentar && type.commentar.trim() !== '') {
               result[type.id] = type.commentar;
            }

            // Рекурсивно спускаємся в childsWorkStageType
            if (type.childsWorkStageType && type.childsWorkStageType.length > 0) {
               traverseTypes(type.childsWorkStageType);
            }
         });
      };

      workPlanStages.forEach(stage => {
         if (stage.workStageTypes) {
            traverseTypes(stage.workStageTypes);
         }
      });

      return result;
   }



   //зміна стану для коменту
   function handleComentChange(id, value) {
      setComent(
         prev => {
            return ({ ...prev, [id]: value })
         }
      )
   }

   //функція для перевірки чи блокувати інпут залежно від статуса
   function isDisabledBecauseOfStatus(status) {
      // Статуси, при яких поле можна буде редагувати
      const editableStatuses = ['new', 'rejected'];
      return !editableStatuses.includes(status);
   }

   // Функция для отримання інтервалу наступного рабочього тижня (понеділок-неділя)(функція іноді дає похибку)
   function getNextWeekInterval() {
      const today = dayjs();
      const nextMonday = today.day() === 0 ? today.add(1, 'day') : today.add(8 - today.day(), 'day');
      const weekStart = nextMonday.startOf('day'); // понеділок 00:00
      const weekEnd = weekStart.add(6, 'day').endOf('day'); // неділя 23:59

      return { weekStart, weekEnd };
   }


   // function filterGraphTypesByWeek(graphStageTypes, weekStart, weekEnd) {
   //    return (graphStageTypes || []).map(type => {
   //       const typeStart = dayjs(type.dateStart);
   //       const typeEnd = dayjs(type.dateEnd);

   //       // Перевіряємо перетин
   //       const intersects = typeEnd.isAfter(weekStart) && typeStart.isBefore(weekEnd);

   //       if (!intersects) return null; // не перетинаються — прибираємо

   //       // Корегуємо дати
   //       const correctedStart = typeStart.isBefore(weekStart) ? weekStart : typeStart;
   //       const correctedEnd = typeEnd.isAfter(weekEnd) ? weekEnd : typeEnd;

   //       return {
   //          ...type,
   //          // повертаєм  ISO 
   //          dateStart: correctedStart.toISOString(),
   //          dateEnd: correctedEnd.toISOString()
   //       };
   //    })
   //       .filter(Boolean); // прибираємо null (не перетинаються)
   // }


   //філтрація типів при створенні плана з графіка початок в 8.00 utc кінець в 18.00 utc

   function filterGraphTypesByWeek(graphStageTypes, weekStart, weekEnd) {
      return (graphStageTypes || []).map(type => {
         const typeStart = dayjs(type.dateStart);
         const typeEnd = dayjs(type.dateEnd);

         // Перевіряємо перетин
         const intersects = typeEnd.isAfter(weekStart) && typeStart.isBefore(weekEnd);

         if (!intersects) return null; // не перетинаються — прибираємо

         // Якщо тип починається раніше тижня — ставимо понеділок 08:00 UTC
         const correctedStartISO = typeStart.isBefore(weekStart)
            ? weekStart.format('YYYY-MM-DD') + 'T08:00:00Z'
            : typeStart.toISOString();

         // Якщо тип закінчується пізніше тижня — ставимо неділю 18:00 UTC
         const correctedEndISO = typeEnd.isAfter(weekEnd)
            ? weekEnd.format('YYYY-MM-DD') + 'T18:00:00Z'
            : typeEnd.toISOString();

         return {
            ...type,
            dateStart: correctedStartISO,
            dateEnd: correctedEndISO
         };
      })
         .filter(Boolean); // прибираємо null (не перетинаються)
   }




   //функція створення плану згідно графіка(запити йдуть паралельно і порядок етапів може бути переплутаним,хоча типи будуть привязані до правильних етапів їх послідовність всередині етапу може змінитися)
   // async function copyWorkPlanFromWorkGraph(graph) {

   //    const { weekStart, weekEnd } = getNextWeekInterval();

   //    // 1. Фільтруємо стадіі сграфа: спочатку фільтруем типи по тижню, потом видаляємо пусті стадіі
   //    const filteredGraph = {
   //       ...graph,
   //       workGraphStages: (graph.workGraphStages || [])
   //          .sort((a, b) => a.id - b.id) //сортування менше айді вище
   //          .map(stage => ({
   //             ...stage,
   //             workGraphTypes: filterGraphTypesByWeek(stage.workGraphTypes, weekStart, weekEnd)
   //             // .sort((a, b) => a.id - b.id)   

   //          }))
   //          .filter(stage => stage.workGraphTypes.length > 0) // видаляємо пусті стадіі
   //    };

   //    console.log('Click')
   //    try {
   //       // -----------------------------
   //       // створюєм WorkPlan
   //       // -----------------------------
   //       const workPlanPayload = {
   //          account: `/api/accounts/${filteredGraph.account.id}`,
   //          agreement: filteredGraph.agreement,
   //          factory: `/api/factories/${filteredGraph.factory.id}`,
   //          engineer: `/api/engineers/${selectedOptionEngineers.value}`,
   //          description: description || filteredGraph.description || "",
   //          status: "new",
   //          dateEntered: new Date().toISOString(),
   //          dateStart: weekStart.toISOString(),
   //          dateEnd: weekEnd.toISOString(),
   //          workGraph: `/api/work_graphs/${filteredGraph.id}`
   //       };

   //       const { data: createdPlan } = await AxiosInstance.post("/work_plans", workPlanPayload);

   //       // -----------------------------
   //       // 2. Створюєм WorkPlanStages через Promise.all
   //       // -----------------------------
   //       const stages = await Promise.all(
   //          filteredGraph.workGraphStages.map(async (graphStage, index) => {
   //             // const list = planStagesStaticList.find(l => l['@id'] === graphStage.workStagesList);
   //             const stagePayload = {
   //                // name: list ? list.name : ``,
   //                name: graphStage.workStagesList.name || '',
   //                description: graphStage.description || "",
   //                dateEntered: new Date().toISOString(),
   //                workPlan: `/api/work_plans/${createdPlan.id}`,
   //                // workStagesList: graphStage.workStagesList,
   //                workStagesList: graphStage.workStagesList['@id']
   //             };

   //             const { data: createdStage } = await AxiosInstance.post("/work_plan_stages", stagePayload);
   //             return { createdStage, graphStage };
   //          })
   //       );

   //       // -----------------------------
   //       // 3. Створюєм workStageTypes для кожного Stage
   //       // -----------------------------
   //       await Promise.all(
   //          stages.map(async ({ createdStage, graphStage }) => {
   //             if (!graphStage.workGraphTypes || graphStage.workGraphTypes.length === 0) return;

   //             await Promise.all(
   //                graphStage.workGraphTypes.map(async (graphType, idx) => {
   //                   const stageTypePayload = {
   //                      workPlanStage: `/api/work_plan_stages/${createdStage.id}`,
   //                      // workTypesList: graphType.workTypeList || null,
   //                      workTypesList: graphType.workTypeList['@id'] || null,
   //                      description: graphType.description || "",
   //                      commentar: graphType.commentar || "",
   //                      dateStart: graphType.dateStart,
   //                      dateEnd: graphType.dateEnd,
   //                      dateEntered: new Date().toISOString(),
   //                   };

   //                   await AxiosInstance.post("/work_stage_types", stageTypePayload);
   //                })
   //             );
   //          })
   //       );
   //       navigate('/work_plans')

   //       return createdPlan;

   //    } catch (error) {
   //       console.error("Помилка при копіюванні WorkPlan:", error);
   //       throw error;
   //    }
   // }

   //функція з послідовним створенням етапів і типів(Не повна після прибирання полів)
   // async function copyWorkPlanFromWorkGraph(graph) {
   //    const { weekStart, weekEnd } = getNextWeekInterval();

   //    const filteredGraph = {
   //       ...graph,
   //       workGraphStages: (graph.workGraphStages || [])
   //          .sort((a, b) => a.id - b.id) // сортування по ID
   //          .map(stage => ({
   //             ...stage,
   //             workGraphTypes: filterGraphTypesByWeek(stage.workGraphTypes, weekStart, weekEnd)
   //                .sort((a, b) => a.id - b.id) // сортування по ID
   //          }))
   //          .filter(stage => stage.workGraphTypes.length > 0)
   //    };

   //    try {

   //       setIsLoading(true)
   //       // Створюєм план
   //       const workPlanPayload = {
   //          account: `/api/accounts/${filteredGraph.account.id}`,
   //          // agreement: filteredGraph.agreement,
   //          agreement: filteredGraph.agreement?.['@id'],
   //          factory: `/api/factories/${filteredGraph.factory.id}`,
   //          engineer: `/api/engineers/${selectedOptionEngineers.value}`,
   //          description: description || filteredGraph.description || "",
   //          status: "new",
   //          dateEntered: new Date().toISOString(),
   //          dateStart: weekStart.toISOString(),
   //          dateEnd: weekEnd.toISOString(),
   //          workGraph: `/api/work_graphs/${filteredGraph.id}`
   //       };

   //       const { data: createdPlan } = await AxiosInstance.post("/work_plans", workPlanPayload);

   //       // Створюємо етапи **послідовно**
   //       for (const graphStage of filteredGraph.workGraphStages) {
   //          const stagePayload = {
   //             name: graphStage.workStagesList.name || '',
   //             description: graphStage.description || "",
   //             dateEntered: new Date().toISOString(),
   //             workPlan: `/api/work_plans/${createdPlan.id}`,
   //             workStagesList: graphStage.workStagesList['@id']
   //          };

   //          const { data: createdStage } = await AxiosInstance.post("/work_plan_stages", stagePayload);

   //          // Створюємо типи цього етап одразу після його створення
   //          if (graphStage.workGraphTypes && graphStage.workGraphTypes.length > 0) {
   //             for (const graphType of graphStage.workGraphTypes) {
   //                const stageTypePayload = {
   //                   workPlanStage: `/api/work_plan_stages/${createdStage.id}`,
   //                   workTypesList: graphType.workTypeList['@id'] || null,
   //                   description: graphType.description || "",
   //                   commentar: graphType.commentar || "",
   //                   dateStart: graphType.dateStart,
   //                   dateEnd: graphType.dateEnd,
   //                   dateEntered: new Date().toISOString()
   //                };

   //                await AxiosInstance.post("/work_stage_types", stageTypePayload);
   //             }
   //          }
   //       }

   //       // navigate('/work_plans');
   //       // navigate('/work_plans', { replace: true, state: { refresh: true } });
   //       window.location.href = '/work_plans';

   //       return createdPlan;

   //    } catch (error) {
   //       console.error("Ошибка при копировании WorkPlan:", error);
   //       throw error;
   //    }
   //    finally {
   //       setIsLoading(false)
   //    }
   // }


   //оновлена функція копіювання





   async function copyWorkPlanFromWorkGraph(graph) {
      const { weekStart, weekEnd } = getNextWeekInterval();


      const filteredGraph = {
         ...graph,
         workGraphStages: (graph.workGraphStages || [])
            .sort((a, b) => a.id - b.id) // сортування по ID
            .map(stage => ({
               ...stage,
               workGraphTypes: filterGraphTypesByWeek(stage.workGraphTypes, weekStart, weekEnd)
                  .sort((a, b) => a.id - b.id) // сортування по ID
            }))
            .filter(stage => stage.workGraphTypes.length > 0)
      };

      try {

         setIsLoading(true)
         // Створюєм план
         const workPlanPayload = {
            account: `/api/accounts/${filteredGraph.account.id}`,
            // agreement: filteredGraph.agreement,
            agreement: filteredGraph.agreement?.['@id'],
            factory: `/api/factories/${filteredGraph.factory.id}`,
            engineer: `/api/engineers/${selectedOptionEngineers.value}`,
            description: description || filteredGraph.description || "",
            status: "new",
            dateEntered: new Date().toISOString(),
            dateStart: weekStart.toISOString(),
            dateEnd: weekEnd.toISOString(),
            // workGraph: `/api/work_graphs/${filteredGraph.id}`//це поле прибрали з воркплан,треба тепер план вязати напряму путом на графік
         };

         const { data: createdPlan } = await AxiosInstance.post("/work_plans", workPlanPayload);

         //блок привязки до ворк граф(нове)
         // 2.1 Беремо існуючі workPlans (IRI)
         const existingWorkPlans = (graph.workPlans || []).map(wp =>
            typeof wp === "string" ? wp : wp["@id"]
         );

         // 2.2 Додаємо новий план
         const updatedWorkPlans = [
            ...existingWorkPlans,
            `/api/work_plans/${createdPlan.id}`
         ];

         // 2.3 Робимо PATCH
         await AxiosInstance.patch(
            `/work_graphs/${graph.id}`,
            {
               workPlans: updatedWorkPlans
            },
            header
         );
         //блок привязки до ворк граф(нове)


         // Створюємо етапи **послідовно**
         for (const graphStage of filteredGraph.workGraphStages) {
            const stagePayload = {
               name: graphStage.workStagesList.name || '',
               description: graphStage.description || "",
               dateEntered: new Date().toISOString(),
               workPlan: `/api/work_plans/${createdPlan.id}`,
               workStagesList: graphStage.workStagesList['@id']
            };

            const { data: createdStage } = await AxiosInstance.post("/work_plan_stages", stagePayload);

            // Створюємо типи цього етап одразу після його створення
            if (graphStage.workGraphTypes && graphStage.workGraphTypes.length > 0) {
               for (const graphType of graphStage.workGraphTypes) {
                  const stageTypePayload = {
                     workPlanStage: `/api/work_plan_stages/${createdStage.id}`,
                     //змінив(1)  workTypesList(там зараз ірі)-раніше був обєкт
                     // workTypesList: graphType.workTypeList['@id'] || null,
                     workTypesList: graphType.workTypeList || null,
                     description: graphType.description || "",
                     commentar: graphType.commentar || "",
                     dateStart: graphType.dateStart,
                     dateEnd: graphType.dateEnd,
                     dateEntered: new Date().toISOString()
                  };

                  await AxiosInstance.post("/work_stage_types", stageTypePayload);
               }
            }
         }

         // navigate('/work_plans');
         // navigate('/work_plans', { replace: true, state: { refresh: true } });
         window.location.href = '/work_plans';

         return createdPlan;

      } catch (error) {
         console.error("Помилка при копіюванні WorkPlan:", error);
         throw error;
      }
      finally {
         setIsLoading(false)
      }
   }




   // console.log('rows', rows)
   console.log('dataState', dataState)
   // console.log('role', role)
   // console.log('userId', userId)
   // console.log('selectedOptionPartner', selectedOptionPartner)
   // console.log('selectedAgreement', selectedAgreement)
   // console.log('selectedOptionStage', selectedOptionStage)
   // console.log('planStages', planStages)
   // console.log('typeSelections[rowId]', typeSelections)
   // console.log('machineriesSelections', machineriesSelections)
   // console.log('measuresSelections', measuresSelections)
   // console.log('newSubtypeName', newSubTypeName)
   // console.log('dateStart', dateStart)
   // console.log('localTypeStages', localTypeStages)
   console.log('workPlan', workPlan)
   // console.log('coment', coment)
   // console.log('extractComent', extractComments(planStages))
   // console.log('workers', workers)
   // console.log('workerProfessionsAll', workerProfessionsAll)
   // console.log('workerProfessionsList', workerProfessionsList)
   // console.log('workersForSelect', workersForSelect)
   // console.log('localWorkersLiss', localWorkersList)
   // console.log('localMachines', localMachines)
   // console.log('engineers', engineers)
   // console.log('graphs', graphs)
   // console.log('graph', workGraph)
   // console.log('user_data', user_data)
   // console.log('userData', JSON.parse(user_data))
   // console.log('planStagesStaticList', planStagesStaticList)
   // console.log('engineers', engineers)
   // console.log('selectedOptionEngineers', selectedOptionEngineers)
   // console.log('dataState.workGraph.id', dataState?.workGraph?.id)
   // console.log('weekStart', weekStart)
   // console.log('weekEnd', weekEnd)


   return (

      <div
         // className='mb-5'
         style={{
            marginBottom: '200px'
            // , marginLeft: '0'
         }}
      >
         {(!dataState && userId !== false) &&
            <>
               {isLoading ?
                  <div
                     style={{
                        position: 'fixed',
                        // height: '100%'
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 10
                     }}
                  >
                     <Spinner animation="border" variant="primary" />
                  </div>
                  : <CreateWorkPlan
                     data={dataState}
                     handleSubmit={handleSubmit}
                     loadOptionsPartners={loadOptionsPartners}
                     selectedOptionPartner={selectedOptionPartner}
                     handleChangePartner={handleChangePartner}
                     // name={name}
                     // setName={setName}
                     description={description}
                     setDescription={setDescription}
                     // descriptionDateStart={descriptionDateStart}
                     // setDescriptionDateStart={setDescriptionDateStart}
                     // descriptionDateEnd={descriptionDateEnd}
                     // setDescriptionDateEnd={setDescriptionDateEnd}
                     loadOptionsFactories={loadOptionsFactory}
                     selectedOptionFactories={selectedOptionFactories}
                     handleChangeFactories={handleChangeFactories}
                     urlRouter={urlRouter}
                     agreementsOptions={agreementsOptions}
                     engineers={engineers}
                     selectedOptionEngineers={selectedOptionEngineers}
                     handleChangeEngineers={handleChangeEngineers}
                     selectedAgreement={selectedAgreement}
                     setSelectedAgreement={setSelectedAgreement}
                     handleChangeAgreement={handleChangeAgreement}
                     graphs={graphs}
                     setSelectedGraph={setSelectedGraph}
                     handleChangeGraph={handleChangeGraph}
                     selectedGraph={selectedGraph}
                     copyWorkPlanFromWorkGraph={copyWorkPlanFromWorkGraph}
                     workGraph={workGraph}
                     weekStart={weekStart}
                     weekEnd={weekEnd}
                  />}
            </>
         }

         {/* статична логіка для існуючого плану */}
         {(dataState && userId != false) &&
            <div
            // style={{ paddingLeft: '0px', overflowX: 'auto' }}
            >

               {/* секція шапки для існуючого плану */}
               {/* <div className="mb-3">
                  <CFormLabel>Період плану</CFormLabel>
                  <div style={{ fontWeight: "bold", fontSize: "1.05rem" }}>
                     {dayjs(dataState.dateStart).format("DD.MM.YYYY")} –{" "}
                     {dayjs(dataState.dateEnd).format("DD.MM.YYYY")}
                  </div>
               </div> */}


               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput1">Контрагент</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput1"
                     value={dataState.account.name}
                     disabled
                     autoComplete="off"
                  />
               </div>

               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput3">Підрозділ</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput3"
                     value={dataState.factory.name}
                     disabled
                     autoComplete="off"
                  />

               </div>

               {/* поле для інженера */}
               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput3">Інженер</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput3"
                     value={engineer?.name}
                     disabled
                     autoComplete="off"
                  />
               </div>

               {/* поле будівельника */}
               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput3">Будівельник</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput3"
                     // value={dataState?.builder?.name}
                     value='Головний будівельник'
                     disabled
                     autoComplete="off"
                  />
               </div>

               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput4">Договори</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput4"
                     value={dataState.agreement.name}
                     disabled
                     autoComplete="off"
                  />
               </div>

               {/* опціі з графіками робіт */}
               {dataState.workGraph ? <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput1">Графіки робіт</CFormLabel>
                  {/* <AsyncSelect */}
                  {/* <Select
                     cacheOptions
                     options={props.graphs}
                     defaultOptions
                     value={props.selectedGraph}
                     onChange={props.handleChangeGraph}
                     className="flex-grow-1"
                  /> */}
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput4"
                     value={`Графік робіт №${dataState.workGraph.id} - ${dataState.account.name} - ${dataState.agreement.name}`}
                     disabled
                     autoComplete="off"
                  />

               </div> : ''}

               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput2">Опис</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput2"
                     value={description}
                     onChange={(e) => setDescription(e.target.value)}
                     autoComplete="off"
                     disabled={isDisabledBecauseOfStatus(workPlan.status)}

                  />
               </div>

               <CButton
                  // type="submit"
                  //  color="success"
                  onClick={handleSubmit}
                  disabled={workPlan?.description === description}
               >
                  Зберегти опис
               </CButton>
               {/* <Link to={urlRouter} className="ms-3">
                  <CButton type="submit" color="secondary">
                     Відміна
                  </CButton>
               </Link> */}

               {/* секція статусів для інженера і будівелика */}
               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  {role === 'ROLE_ADMIN' && <div style={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
                     <StatusItem
                        status={opStatus}
                        // status={true}
                        textTrue='Підтверджено ОП'
                        textFalse='Не підтверджено ОП'
                        dateConfirm={dataState?.dateComfirmedOp || ''}
                     // dateConfirm='2026-02-12T10:51:32+00:00'
                     // dateConfirm="2025-01-10 14:35"
                     // dateConfirm='2025-12-08T09:04:36+00:00'
                     // dateCobfirm=''
                     />
                     <StatusItem status={ingeneerStatus} textTrue='Підтверджено інженером' textFalse='Не підтверджено інженером' dateConfirm={dataState?.dateComfirmedEngineer || ''} />
                     <StatusItem status={constructorStatus} textTrue='Підтверджено будівельником' textFalse='Не підтверджено будівельником' dateConfirm={dataState?.dateComfirmedConstructor || ''} />
                  </div>
                  }
                  {role === 'ROLE_PARTNER' && <div style={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
                     <StatusItem status={opStatus} textTrue='Підтверджено ОП' textFalse='Не підтверджено ОП' dateConfirm={dataState?.dateComfirmedOp || ''} />
                     <StatusItem status={ingeneerStatus} textTrue='Підтверджено інженером' textFalse='Не підтверджено інженером' dateConfirm={dataState?.dateComfirmedEngineer || ''} />
                     <StatusItem status={constructorStatus} textTrue='Підтверджено будівельником' textFalse='Не підтверджено будівельником' dateConfirm={dataState?.dateComfirmedConstructor || ''} />
                  </div>
                  }
               </div>

               {/* секція статусів для інженера і будівелика */}

               {/* тут вивід комента  ворк плана*/}
               <div className="mb-3" style={{
                  marginTop: '20px',
                  textAlign: 'center',
               }}>
                  <CFormLabel style={{
                     fontSize: '18px',
                     fontWeight: '700',
                  }}
                  >Коментар - зауваження</CFormLabel>

                  {!workPlan?.commentar ? (
                     <div style={{ color: 'green', fontWeight: 500 }}>
                        Коментар-зауваження відсутній
                     </div>
                  ) : (
                     <div style={{ color: 'red', fontWeight: 500 }}>
                        {workPlan.commentar}
                     </div>
                  )}
               </div>
               {/* тут вивід комента ворк плана*/}

               {/* Блок редагування дат типу */}
               <div className="mb-3" style={{
                  marginTop: '20px',
                  //  textAlign: 'center'
                  textAlign: 'left'
               }}>
                  {role === 'ROLE_ADMIN' && (
                     !isDateEditingAllowed
                        ? <CButton color="success" variant="outline" onClick={handleAllowDateEditing}>
                           Дозволити редагувати дати
                        </CButton>
                        : <CButton color="danger" variant="outline" onClick={handleDisallowDateEditing}>
                           Заборонити редагувати дати
                        </CButton>
                  )}
                  <div style={{ marginTop: '8px', fontWeight: 500, color: isDateEditingAllowed ? 'green' : 'red' }}>
                     {isDateEditingAllowed ? 'Редагування дат у довільному інтервалі дозволено' : 'Редагування дат  у довільному інтервалі заборонено'}
                  </div>
               </div>
               {/* Блок редагування дат типу */}




               {/* Початок таблиці плану */}
               {/* додаєм дів для скролу плану */}
               <div style={{ display: 'flex', gap: 10, marginBottom: 10, marginTop: '50px' }}>

                  <AsyncSelect
                     isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                     loadOptions={loadOptionsStages}
                     // defaultOptions
                     defaultOptions={localStagesList}
                     value={selectedOptionStage}
                     onChange={(select) => setSelectedOptionStage(select)}
                     styles={{
                        control: (base) => ({
                           ...base,
                           width: '400px',
                        }),
                        menu: (base) => ({
                           ...base,
                           width: '400px',
                           maxHeight: '200px',
                           overflowY: 'auto'
                        }),
                     }}
                  >
                     {/* {stages.map((s) => (
                        <option key={s.id} value={s.id}>
                           {s.stage}
                        </option>
                     ))} */}
                  </AsyncSelect>
                  <CButton
                     color='secondary'
                     onClick={handleAddStage}
                     disabled={isDisabledBecauseOfStatus(workPlan.status)}
                  >Додати етап</CButton>
               </div>

               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                     <tr>
                        {/* <th style={thStyle}>Етап</th> */}
                        {/* <th style={{ ...thStyle, width: 200 }}>Тип робіт</th> */}
                        <th style={thStyle}>Тип робіт</th>
                        <th style={{ ...thStyle, width: 120 }}>Початок</th>
                        <th style={{ ...thStyle, width: 120 }}>Кінець</th>
                        <th style={{ ...thStyle, width: 120 }}>П.І.Б.</th>
                        {/* Змінив ширину кваліфікаціі */}
                        {/* <th style={thStyle}>Кваліфікація</th> */}
                        <th style={{ ...thStyle, width: 300 }}>Кваліфікація</th>
                        <th style={thStyle}>Спецтехніка</th>
                        {/* <th style={{ ...thStyle, width: 120 }}>Захід з ОП</th> */}
                        <th style={thStyle}>Захід з ОП</th>
                        <th style={thStyle}>Дії</th>
                     </tr>
                  </thead>
                  <tbody>
                     {/* {rows.map((row) => ( */}
                     {planStages?.

                        //сортування
                        slice().                    // копія
                        sort((a, b) => a.id - b.id).    // сортування останні айді знизу


                        map((row) => {
                           // console.log('row', row)
                           return <React.Fragment key={row.id}>
                              <tr style={{ background: '#f3f3f3', fontWeight: 'bold' }}>
                                 <td colSpan="9" style={tdStyle}>
                                    {/* {row.stage} */}
                                    {row?.name}
                                    <CButton
                                       color='secondary'
                                       onClick={() => handleDeleteRow(row.id)}
                                       style={{ marginLeft: 10 }}
                                       disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                    >
                                       Видалити етап
                                    </CButton>
                                 </td>
                              </tr>

                              {/* {row?.types?.map((type) => (  */}
                              {row?.workStageTypes?.
                                 //сортування

                                 slice() // робимо копію,щоб не мутувати  массив
                                 // .sort((a, b) => b.id - a.id). // сортируем останнє афді має бути зверху
                                 .sort((a, b) => a.id - b.id). // сортуємо останнє афді має бути знизу


                                 map((type) => {
                                    return <>
                                       <tr key={type?.id}>
                                          {/* <td style={tdStyle}></td> */}
                                          <td style={tdStyle}>
                                             <textarea
                                                value={type?.workTypesList?.name}
                                                disabled
                                                style={{
                                                   minHeight: 24,
                                                   resize: 'none',
                                                   overflow: 'hidden',
                                                   border: 'none',
                                                   padding: '4px',
                                                   fontFamily: 'inherit',
                                                   fontSize: 'inherit',
                                                   boxSizing: 'border-box',
                                                }}
                                                onInput={(e) => {
                                                   e.target.style.height = 'auto';
                                                   e.target.style.height = e.target.scrollHeight + 'px';
                                                }}
                                             />

                                             {/* Коментар до типу для адміна бачить і адмін */}
                                             {(role === 'ROLE_ADMIN' && workPlan.status === 'send-to-verify') && <textarea
                                                value={coment[type.id] || ''}
                                                onChange={(e) => handleComentChange(type.id, e.target.value)}
                                                placeholder="Коментар-зауваження"
                                                style={{
                                                   width: '100%',
                                                   minHeight: 24,
                                                   resize: 'none',
                                                   overflow: 'hidden',
                                                   border: '1px solid #ccc',
                                                   padding: '4px',
                                                   marginTop: 4,
                                                   fontFamily: 'inherit',
                                                   fontSize: 'inherit',
                                                   boxSizing: 'border-box',
                                                }}
                                                onInput={(e) => {
                                                   e.target.style.height = 'auto';
                                                   e.target.style.height = e.target.scrollHeight + 'px';
                                                }}
                                             />}
                                             {/* коментар для партнера від адміна */}
                                             {(type.commentar !== '' && type.commentar !== undefined) && <textarea
                                                // value={coment[type.id] || ''}
                                                value={type?.commentar}
                                                placeholder=""
                                                disabled
                                                style={{
                                                   width: '100%',
                                                   minHeight: 24,
                                                   resize: 'none',
                                                   overflow: 'hidden',
                                                   border: '1px solid #ccc',
                                                   padding: '4px',
                                                   marginTop: 4,
                                                   fontFamily: 'inherit',
                                                   fontSize: 'inherit',
                                                   boxSizing: 'border-box',
                                                   color: 'red'
                                                }}
                                                onInput={(e) => {
                                                   e.target.style.height = 'auto';
                                                   e.target.style.height = e.target.scrollHeight + 'px';
                                                }}
                                             />}



                                             {/* Кнопка додати підтип */}
                                             <button
                                                onClick={() => setSubtypeLogicBlock(prev => ({ ...prev, [type.id]: true }))}
                                                style={{ alignSelf: 'flex-start', padding: '2px 6px', fontSize: '12px' }}
                                             >
                                                {/* Додати підтип */}+
                                             </button>
                                             <button
                                                onClick={() => setSubtypeLogicBlock(prev => ({ ...prev, [type.id]: false }))}
                                                style={{ alignSelf: 'flex-start', padding: '2px 6px', fontSize: '12px' }}
                                             >
                                                {/* Додати підтип */}-
                                             </button>


                                          </td>
                                          <td
                                             style={{ ...tdStyle, minWidth: '120px' }}
                                          // style={tdStyle}
                                          >
                                             <DatePicker

                                                selected={dateStart[type.id] ? new Date(dateStart[type.id]) : null}
                                                onChange={(date) => {
                                                   handleChangeTimeStart(type.id, date);
                                                }}
                                                dateFormat="yyyy-MM-dd"
                                                className="form-control"
                                                disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                //
                                                // minDate={new Date(weekStart)}
                                                // maxDate={new Date(weekEnd)}
                                                minDate={isDateEditingAllowed ? undefined : new Date(weekStart)}
                                                maxDate={isDateEditingAllowed ? undefined : new Date(weekEnd)}

                                             />


                                          </td>
                                          <td
                                             style={{ ...tdStyle, minWidth: '120px' }}
                                          // style={tdStyle}
                                          >
                                             <DatePicker
                                                selected={dateEnd[type.id] ? new Date(dateEnd[type.id]) : null}
                                                onChange={(date) => {
                                                   handleChangeTimeEnd(type.id, date);

                                                }}

                                                dateFormat="yyyy-MM-dd"
                                                className="form-control"
                                                disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                // minDate={new Date(weekStart)}
                                                // maxDate={new Date(weekEnd)}
                                                minDate={isDateEditingAllowed ? undefined : new Date(weekStart)}
                                                maxDate={isDateEditingAllowed ? undefined : new Date(weekEnd)}

                                             />
                                          </td>

                                          {/* ПІБ + кнопка видалити робітника */}
                                          <td style={tdStyle}>
                                             {/* {type?.workers?.map((w, idx) => ( */}
                                             {type?.workStageTypeWorkers?.

                                                // сортування
                                                slice() // робимо копію,щоб не мутувати  массив
                                                .sort((a, b) => a.id - b.id). // сортуємо останнє афді має бути знизу


                                                map((w, idx) => {
                                                   // console.log('w', w)
                                                   return <div key={idx} style={{ display: 'flex', marginBottom: 3 }}>
                                                      <input type="text" value={w.worker?.fullName} disabled style={{ width: 'calc(100% - 25px)', height: '36px' }} />
                                                      <button
                                                         onClick={() => {
                                                            handleDeleteWorker(row.id, type.id, w.id)
                                                         }}
                                                         style={{ width: 25, marginLeft: 2 }}
                                                         disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                      >
                                                         ×
                                                      </button>
                                                   </div>
                                                }

                                                )}
                                             <div style={{ display: 'flex', gap: '2px' }}>

                                                <AsyncSelect
                                                   isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                   loadOptions={loadOptionsWorkers}
                                                   // defaultOptions
                                                   defaultOptions={localWorkersList}
                                                   value={
                                                      workerSelections[type.id]
                                                         ? { label: workerSelections[type.id].label, value: workerSelections[type.id].value }
                                                         : null
                                                   }
                                                   onChange={(option) => {
                                                      setWorkerSelections(prev => ({
                                                         ...prev,
                                                         [type.id]: option
                                                      }));
                                                   }}

                                                   styles={{
                                                      control: (base) => ({
                                                         ...base,
                                                         width: '300px',
                                                      }),
                                                      menu: (base) => ({
                                                         ...base,
                                                         width: '300px',
                                                         maxHeight: '200px',
                                                         overflowY: 'auto',
                                                         // height: '36px',
                                                      }),
                                                   }}
                                                />
                                                <button
                                                   disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                   onClick={() => handleAddWorker(row.id, type.id)}
                                                >+
                                                   {/* Додати */}
                                                </button>
                                             </div>
                                          </td>

                                          {/* Кваліфікація */}
                                          <td style={tdStyle}>
                                             {type?.workStageTypeWorkers?.

                                                //сортування

                                                slice() // робимо копію,щоб не мутувати  массив
                                                // .sort((a, b) => b.id - a.id). // сортируем останнє афді має бути зверху
                                                .sort((a, b) => a.id - b.id). // сортуємо останнє афді має бути знизу

                                                map((w, idx) => {
                                                   // console.log('w', w)
                                                   // console.log('workersForSelect', workersForSelect)
                                                   const workerOption = workersForSelect.find(elem => elem.id == w.worker?.id)?.workerProffessions
                                                   // console.log('workerOption', workerOption)
                                                   const optionsForProfession = workerOption
                                                      //міняю
                                                      //тут бере нульовий айтем(нам не підходить)
                                                      // ?.filter(per => {
                                                      //    // console.log('per', per)
                                                      //    return workerProfessionsAll[`${w.worker.id}`]?.find(
                                                      //       k => {
                                                      //          // console.log('k', k)
                                                      //          return ((k.id == per.id) && k.workerProffesionDocs?.[0]?.status === 'verified')
                                                      //       }
                                                      //    )
                                                      // }
                                                      // )
                                                      ?.filter(per => {
                                                         const professionInAll = workerProfessionsAll[`${w.worker.id}`]?.find(k => k.id === per.id);
                                                         if (!professionInAll?.workerProffesionDocs?.length) return false;

                                                         // находимо документ с більшим id(значить він останній)
                                                         const lastDoc = professionInAll.workerProffesionDocs.reduce((prev, curr) => {
                                                            return curr.id > prev.id ? curr : prev;
                                                         }, professionInAll.workerProffesionDocs[0]);

                                                         return lastDoc.status === 'verified';
                                                      })
                                                      .map(e => ({

                                                         label: e.workerProffessionList.name,
                                                         value: e.id
                                                      })) || [];
                                                   // console.log('options', optionsForProfession)
                                                   return (
                                                      // <div key={idx} style={{ marginBottom: 3 }}>
                                                      //    <input type="text" value={w.qualification} disabled style={{ width: '100%' }} />
                                                      // </div>
                                                      // Робимо блок для додавання позиціі з воркера
                                                      <div id={`worker-select-${w.id}`} style={{ width: '400px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                         <Select
                                                            isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                            key={idx}
                                                            options={optionsForProfession}
                                                            placeholder="Виберіть професію"
                                                            // value={optionsForProfession[0]}
                                                            //варіант з відкритим  w.workerProffessions
                                                            // value={optionsForProfession.find(opt => opt.value === w.workerProffessions?.id) || null}
                                                            //варіант з закритим w.workerProffessions
                                                            value={optionsForProfession.find(opt => opt.value === Number(getIdFromIri(w.workerProffessions))) || null}

                                                            onChange={(selected) => handleSelectProfession(w.id, selected)}
                                                            styles={{
                                                               container: (provided) => ({
                                                                  ...provided,
                                                                  width: 200,
                                                               }),
                                                               // control: (provided) => ({
                                                               //    ...provided,
                                                               //    minHeight: 36,
                                                               // }),
                                                               control: (provided) => ({
                                                                  ...provided,
                                                                  // borderColor: (showProfessionErrors && !w.workerProffessions && !w.worker?.position)
                                                                  //    ? 'red'
                                                                  //    : provided.borderColor,
                                                                  borderColor: professionErrors[w.id] ? 'red' : provided.borderColor,
                                                               })
                                                            }}

                                                         />
                                                         {(!w.workerProffessions) && <div style={{
                                                            width: 180,
                                                            height: 36, color: 'green'
                                                         }}>

                                                            {(w.worker?.position && `${w.worker?.position}`) || 'Посада не додана'}
                                                         </div>}
                                                      </div>
                                                      // Робимо блок для додавання позиціі з воркера
                                                   )
                                                }
                                                )

                                             }
                                          </td>

                                          {/* Спецтехніка */}
                                          <td style={tdStyle}>
                                             {type?.specialMachinery?.map((w, idx) => (
                                                <div key={idx} style={{ marginBottom: 3, display: 'flex' }}>
                                                   <input
                                                      disabled
                                                      type="text"
                                                      value={w.name}
                                                      // onChange={(e) =>
                                                      //    handleChangeWorkerField(row.id, type.id, idx, 'safety', e.target.value)
                                                      // }
                                                      style={{ width: '100%', height: '36px' }}
                                                   />
                                                   <button
                                                      onClick={() => handleDeleteMachine(type.id, w.id)}
                                                      style={{ width: 25, marginLeft: 2 }}
                                                      disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                   >
                                                      ×
                                                   </button>

                                                </div>
                                             ))}
                                             <AsyncSelect
                                                isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                loadOptions={loadOptionsMachines}
                                                // defaultOptions
                                                defaultOptions={localMachines}
                                                value={machineriesSelections[type.id] || null}
                                                onChange={(option) => {
                                                   setMachineriesSelections((prev) => ({
                                                      ...prev,
                                                      [type.id]: option,
                                                   }))

                                                   handleAddMachine(type.id, option);
                                                }
                                                }
                                                styles={{
                                                   control: (base) => ({ ...base, width: '300px', height: '36px' }),
                                                   menu: (base) => ({ ...base, width: '300px' }),
                                                }}
                                             />
                                          </td>

                                          {/* Захід з ОП */}
                                          <td style={tdStyle}>
                                             {type?.safetyMeasuresList?.map((w, idx) => (
                                                <div key={idx} style={{ marginBottom: 3 }}>
                                                   <input
                                                      disabled
                                                      type="text"
                                                      value={w.name}
                                                      style={{
                                                         //  width: '100%',
                                                         height: '36px',
                                                         width: '600px'
                                                      }}
                                                   />
                                                </div>
                                             ))}
                                             <AsyncSelect
                                                isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                loadOptions={loadOptionsMeasures}
                                                // defaultOptions
                                                defaultOptions={localMeasuresList}

                                                value={measuresSelections[type?.id] || null}
                                                onChange={(option) => {
                                                   setMeasuresSelections(prev => ({
                                                      ...prev,
                                                      [type?.id]: option
                                                   }));

                                                   handleAddMeasure(type.id, option);
                                                }}
                                                styles={{
                                                   control: (base) => ({ ...base, width: '300px', height: '36px' }),
                                                   menu: (base) => ({ ...base, width: '300px' }),
                                                }}
                                             />

                                          </td>

                                          {/* Дії: кнопка видалити тип */}
                                          <td style={tdStyle}>
                                             <button
                                                onClick={() => handleDeleteType(row.id, type.id)}
                                                disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                             >×</button>
                                          </td>
                                       </tr>
                                       {/* тут спробувати запхати підтипи */}
                                       {subtypeLogicBlock[type.id] && <>
                                          {/* Блок створених підтипів  */}
                                          {type?.childsWorkStageType.

                                             //сортування

                                             slice() // робимо копію,щоб не мутувати  массив
                                             // .sort((a, b) => b.id - a.id). // сортируем останнє афді має бути зверху
                                             .sort((a, b) => a.id - b.id). // сортуємо останнє афді має бути знизу

                                             map((st) => {
                                                // console.log('st', st)
                                                return <tr key={st.id} style={{
                                                   //  background: '#f9f9f9',
                                                   background: '#87CEFA',
                                                   borderTop: '2px solid blue', borderLeft: '2px solid blue', borderRight: '2px solid blue', borderBottom: '2px solid blue'
                                                }}>

                                                   <td style={tdStyle}>
                                                      <textarea
                                                         value={st.description}
                                                         placeholder="Назва підтипу"
                                                         disabled
                                                         // onChange={(e) =>
                                                         //    handleChangeSubTypeField(st.id, 'workTypesList', { name: e.target.value })
                                                         // }
                                                         style={{
                                                            width: '100%',
                                                            minHeight: 24,
                                                            resize: 'none',
                                                            overflow: 'hidden',
                                                            padding: '4px',
                                                            height: '100px'
                                                         }}
                                                         onInput={(e) => {
                                                            e.target.style.height = 'auto';
                                                            e.target.style.height = e.target.scrollHeight + 'px';
                                                         }}
                                                      />

                                                      {/* Коментар до типу для адміна бачить і адмін */}
                                                      {(role === 'ROLE_ADMIN' && workPlan.status === 'send-to-verify') && <textarea
                                                         value={coment[st.id] || ''}
                                                         onChange={(e) => handleComentChange(st.id, e.target.value)}
                                                         placeholder="Коментар-зауваження"
                                                         style={{
                                                            width: '100%',
                                                            minHeight: 24,

                                                            resize: 'none',
                                                            overflow: 'hidden',
                                                            border: '1px solid #ccc',
                                                            padding: '4px',
                                                            marginTop: 4,
                                                            fontFamily: 'inherit',
                                                            fontSize: 'inherit',
                                                            boxSizing: 'border-box',

                                                         }}
                                                         onInput={(e) => {
                                                            e.target.style.height = 'auto';
                                                            e.target.style.height = e.target.scrollHeight + 'px';
                                                         }}
                                                      />}
                                                      {/* коментар для партнера від адміна */}
                                                      {(st?.commentar !== '' && st?.commentar !== undefined) ? <textarea
                                                         // value={coment[type.id] || ''}
                                                         value={st?.commentar}
                                                         // onChange={(e) => handleComentChange(type.id, e.target.value)}
                                                         placeholder=""
                                                         disabled
                                                         style={{
                                                            width: '100%',
                                                            minHeight: 24,
                                                            resize: 'none',
                                                            overflow: 'hidden',
                                                            border: '1px solid #ccc',
                                                            padding: '4px',
                                                            marginTop: 4,
                                                            fontFamily: 'inherit',
                                                            fontSize: 'inherit',
                                                            boxSizing: 'border-box',
                                                            color: 'red',
                                                            height: 'auto'
                                                         }}
                                                         onInput={(e) => {
                                                            e.target.style.height = 'auto';
                                                            e.target.style.height = e.target.scrollHeight + 'px';
                                                         }}
                                                      /> : ''}


                                                   </td>
                                                   <td style={tdStyle}>
                                                      <DatePicker
                                                         disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                         // selected={st.dateStart ? new Date(st.dateStart) : null}
                                                         // onChange={(date) => handleChangeSubTypeField(st.id, 'dateStart', date)}
                                                         dateFormat="yyyy-MM-dd"
                                                         className="form-control"
                                                         selected={dateStart[st.id] ? new Date(dateStart[st.id]) : null}
                                                         onChange={(date) => {
                                                            handleChangeTimeStart(st.id, date);

                                                         }}
                                                         //
                                                         // minDate={new Date(weekStart)}
                                                         // maxDate={new Date(weekEnd)}
                                                         minDate={isDateEditingAllowed ? undefined : new Date(weekStart)}
                                                         maxDate={isDateEditingAllowed ? undefined : new Date(weekEnd)}

                                                      />
                                                   </td>
                                                   <td style={tdStyle}>
                                                      <DatePicker
                                                         disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                         // selected={st.dateEnd ? new Date(st.dateEnd) : null}
                                                         // onChange={(date) => handleChangeSubTypeField(st.id, 'dateEnd', date)}
                                                         selected={dateEnd[st.id] ? new Date(dateEnd[st.id]) : null}
                                                         onChange={(date) => {
                                                            handleChangeTimeEnd(st.id, date);

                                                         }}
                                                         dateFormat="yyyy-MM-dd"
                                                         className="form-control"
                                                         //
                                                         // minDate={new Date(weekStart)}
                                                         // maxDate={new Date(weekEnd)}
                                                         minDate={isDateEditingAllowed ? undefined : new Date(weekStart)}
                                                         maxDate={isDateEditingAllowed ? undefined : new Date(weekEnd)}

                                                      />
                                                   </td>


                                                   {/* ПІБ до субтипу + кнопка видалити робітника */}
                                                   <td style={tdStyle}>
                                                      {
                                                         // type?.childsWorkStageType?.map((st) => (
                                                         st.workStageTypeWorkers?.

                                                            //сортування

                                                            slice() // робимо копію,щоб не мутувати  массив
                                                            // .sort((a, b) => b.id - a.id). // сортируем останнє афді має бути зверху
                                                            .sort((a, b) => a.id - b.id). // сортуємо останнє афді має бути знизу



                                                            map((w, idx) => {
                                                               // console.log('!!!!!!!!!!!');
                                                               // console.log('w', w);
                                                               return (
                                                                  <div key={idx} style={{ display: 'flex', marginBottom: 3 }}>
                                                                     <input
                                                                        type="text"
                                                                        value={w?.worker?.fullName}
                                                                        disabled
                                                                        style={{ width: 'calc(100% - 25px)', height: '36px' }}
                                                                     />
                                                                     <button
                                                                        disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                                        onClick={() => handleDeleteWorker(row.id, st.id, w.id)}
                                                                        style={{ width: 25, marginLeft: 2 }}
                                                                     >
                                                                        ×
                                                                     </button>
                                                                  </div>
                                                               );
                                                            }
                                                            )
                                                         // ))
                                                      }

                                                      <div style={{ display: 'flex', gap: '2px' }}>

                                                         <AsyncSelect
                                                            isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                            loadOptions={loadOptionsWorkers}
                                                            // defaultOptions
                                                            defaultOptions={localWorkersList}
                                                            value={
                                                               workerSelections[st.id]
                                                                  ? { label: workerSelections[st.id].label, value: workerSelections[st.id].value }
                                                                  : null
                                                            }
                                                            onChange={(option) => {
                                                               setWorkerSelections(prev => ({
                                                                  ...prev,
                                                                  [st.id]: option
                                                               }));
                                                            }}

                                                            styles={{
                                                               control: (base) => ({
                                                                  ...base,
                                                                  width: '300px',
                                                               }),
                                                               menu: (base) => ({
                                                                  ...base,
                                                                  width: '300px',
                                                                  maxHeight: '200px',
                                                                  overflowY: 'auto',
                                                                  // height: '36px',
                                                               }),
                                                            }}
                                                         />
                                                         <button
                                                            disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                            onClick={() => handleAddWorker(row.id, st.id)}
                                                         >+
                                                            {/* Додати */}
                                                         </button>
                                                      </div>
                                                   </td>

                                                   {/* Кваліфікація до субтипу */}
                                                   <td style={tdStyle}>
                                                      {
                                                         st.workStageTypeWorkers?.
                                                            //сортування

                                                            slice() // робимо копію,щоб не мутувати  массив
                                                            // .sort((a, b) => b.id - a.id). // сортируем останнє афді має бути зверху
                                                            .sort((a, b) => a.id - b.id). // сортуємо останнє афді має бути знизу


                                                            map((w, idx) => {

                                                               //   місце для переносу логіки кваліфікаціі з селектом
                                                               // console.log('w', w)
                                                               // console.log('workersForSelect', workersForSelect)
                                                               const workerOption = workersForSelect.find(elem => elem.id === w.worker.id)?.workerProffessions
                                                               const optionsForProfession = workerOption
                                                                  // додаємо фільтр як в типах
                                                                  ?.filter(per => {
                                                                     const professionInAll = workerProfessionsAll[`${w.worker.id}`]?.find(k => k.id === per.id);
                                                                     if (!professionInAll?.workerProffesionDocs?.length) return false;

                                                                     // беремо документ з максимальним id
                                                                     const lastDoc = professionInAll.workerProffesionDocs.reduce((prev, curr) =>
                                                                        curr.id > prev.id ? curr : prev,
                                                                        professionInAll.workerProffesionDocs[0]
                                                                     );

                                                                     return lastDoc.status === 'verified';
                                                                  })

                                                                  ?.map(e => ({
                                                                     label: e.workerProffessionList.name,
                                                                     value: e.id
                                                                  })) || [];
                                                               // console.log('options', optionsForProfession)
                                                               return (
                                                                  // <div key={idx} style={{ marginBottom: 3 }}>
                                                                  //    <input type="text" value={w.qualification} disabled style={{ width: '100%' }} />
                                                                  // </div>
                                                                  // Робимо блок для додавання позиціі з воркера
                                                                  <div id={`worker-select-${w.id}`} style={{ width: '400px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                                     <Select
                                                                        isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                                        key={idx}
                                                                        options={optionsForProfession}
                                                                        placeholder="Виберіть професію"
                                                                        // value={optionsForProfession.find(opt => opt.value === w.workerProffessions?.id) || null}
                                                                        //варіант з відкритим  w.workerProffessions
                                                                        // value={optionsForProfession.find(opt => opt.value === w.workerProffessions?.id) || null}
                                                                        //варіант з закритим w.workerProffessions
                                                                        value={optionsForProfession.find(opt => opt.value === Number(getIdFromIri(w.workerProffessions))) || null}

                                                                        onChange={(selected) => handleSelectProfession(w.id, selected)}
                                                                        styles={{
                                                                           container: (provided) => ({
                                                                              ...provided,
                                                                              width: 200,
                                                                           }),
                                                                           // control: (provided) => ({
                                                                           //    ...provided,
                                                                           //    minHeight: 36,
                                                                           // }),
                                                                           control: (provided) => ({
                                                                              ...provided,
                                                                              minHeight: 36,
                                                                              // borderColor: (showProfessionErrors && !w.workerProffessions && !w.worker?.position)
                                                                              //    ? 'red'
                                                                              //    : provided.borderColor,
                                                                              borderColor: professionErrors[w.id] ? 'red' : provided.borderColor,

                                                                           }),

                                                                        }}

                                                                     />
                                                                     {/** */}
                                                                     {(!w.workerProffessions) && <div style={{
                                                                        width: 180,
                                                                        height: 36, color: 'green'
                                                                     }}>

                                                                        {/* {w.worker?.position || 'Посада не додана'} */}
                                                                        {(w.worker?.position && `${w.worker?.position}`) || 'Посада не додана'}
                                                                     </div>}
                                                                     {/** */}
                                                                  </div>
                                                               )

                                                               //  місце для переносу

                                                            })
                                                      }
                                                   </td>
                                                   {/* Спецтехніка до субтипу */}
                                                   <td style={tdStyle}>
                                                      {
                                                         // type?.childsWorkStageType?.map((st) =>
                                                         st.specialMachinery?.map((w, idx) => (
                                                            <div key={idx} style={{ marginBottom: 3, display: 'flex' }}>
                                                               <input
                                                                  disabled
                                                                  type="text"
                                                                  value={w.name}
                                                                  style={{ width: '100%', height: '36px' }}
                                                               />
                                                               <button
                                                                  onClick={() => handleDeleteMachine(st.id, w.id)}
                                                                  style={{ width: 25, marginLeft: 2 }}
                                                                  disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                               >
                                                                  ×
                                                               </button>
                                                            </div>
                                                         ))
                                                         // )
                                                      }

                                                      <AsyncSelect
                                                         isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                         loadOptions={loadOptionsMachines}
                                                         // defaultOptions
                                                         defaultOptions={localMachines}
                                                         value={machineriesSelections[st.id] || null}
                                                         onChange={(option) => {
                                                            setMachineriesSelections((prev) => ({
                                                               ...prev,
                                                               [st.id]: option,
                                                            }));
                                                            handleAddMachine(st.id, option);
                                                         }}
                                                         styles={{
                                                            control: (base) => ({ ...base, width: '300px', height: '36px' }),
                                                            menu: (base) => ({ ...base, width: '300px' }),
                                                         }}
                                                      />
                                                   </td>
                                                   {/* Захід з ОП до субтипу */}
                                                   <td style={tdStyle}>
                                                      {
                                                         // type?.childsWorkStageType?.map((st) =>
                                                         st.safetyMeasuresList?.map((w, idx) => (
                                                            <div key={idx} style={{ marginBottom: 3 }}>
                                                               <input
                                                                  disabled
                                                                  type="text"
                                                                  value={w.name}
                                                                  style={{ height: '36px', width: '600px' }}
                                                               />
                                                            </div>
                                                         ))
                                                         // )
                                                      }

                                                      <AsyncSelect
                                                         isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                         loadOptions={loadOptionsMeasures}
                                                         // defaultOptions
                                                         defaultOptions={localMeasuresList}
                                                         value={measuresSelections[st?.id] || null}
                                                         onChange={(option) => {
                                                            setMeasuresSelections((prev) => ({
                                                               ...prev,
                                                               [st?.id]: option,
                                                            }));
                                                            handleAddMeasure(st?.id, option);
                                                         }}
                                                         styles={{
                                                            control: (base) => ({ ...base, width: '300px', height: '36px' }),
                                                            menu: (base) => ({ ...base, width: '300px' }),
                                                         }}
                                                      />
                                                   </td>

                                                   {/* Дії до підтипу: кнопка видалити тип */}
                                                   <td style={tdStyle}>
                                                      <button
                                                         disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                         onClick={() => handleDeleteType(row.id, st.id)}
                                                      >×</button>
                                                   </td>

                                                </tr>
                                             }

                                             )}

                                          {/* Блок підтипів */}
                                          {/* блок для створення нового підтипу */}
                                          <tr style={{
                                             // background: '#f9f9f9',
                                             backgroundColor: '#87CEFA',
                                             borderBottom: '2px solid blue', borderLeft: '2px solid blue', borderRight: '2px solid blue', borderTop: '2px solid blue'
                                          }}>
                                             <td style={tdStyle}>
                                                <textarea
                                                   disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                   placeholder="Назва підтипу"
                                                   value={newSubTypeName[type.id] || ''}
                                                   onChange={(e) =>
                                                      setNewSubTypeName((prev) => ({ ...prev, [type.id]: e.target.value }))
                                                   }
                                                   style={{
                                                      width: '100%',
                                                      minHeight: 24,
                                                      resize: 'none',
                                                      overflow: 'hidden',
                                                      padding: '4px',
                                                   }}
                                                   onInput={(e) => {
                                                      e.target.style.height = 'auto';
                                                      e.target.style.height = e.target.scrollHeight + 'px';
                                                   }}
                                                />
                                                <button
                                                   disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                                   onClick={() => handleAddSubType(type.id)}
                                                   style={{ marginTop: 4 }}
                                                >
                                                   Зберегти підтип
                                                </button>
                                             </td>
                                          </tr>
                                          {/* блок для створення нового підтипу */}
                                       </>
                                       }

                                       {/* тут спробувати запхати підтипи */}

                                    </>
                                 }
                                 )}

                              {/* Селект для додавання нового типа */}
                              <tr>
                                 <td style={tdStyle}></td>
                                 <td colSpan="8" style={tdStyle}>
                                    <AsyncSelect
                                       isDisabled={isDisabledBecauseOfStatus(workPlan.status)}
                                       // defaultOptions
                                       defaultOptions={localTypeStages}
                                       loadOptions={loadOptionsTypes}
                                       value={typeSelections[row.id] || null}
                                       onChange={(option) => handleChangeType(row.id, option)}
                                       styles={{
                                          control: (base) => ({
                                             ...base,
                                             width: '300px',
                                          }),
                                          menu: (base) => ({
                                             ...base,
                                             width: '300px',
                                             maxHeight: '200px',
                                             overflowY: 'auto'
                                          }),
                                       }}

                                    >

                                    </AsyncSelect>
                                    <CButton
                                       disabled={isDisabledBecauseOfStatus(workPlan.status)}
                                       color='secondary' onClick={() => handleAddType(row?.id)}>+
                                       {/* Додати тип */}
                                    </CButton>
                                 </td>
                              </tr>
                           </React.Fragment>
                        }

                        )}
                  </tbody>
               </table>

               {/* блок для зміни статуса */}
               {/* блок партнера */}
               <div className='mt-5'
                  //  className={css.infoBlock__bottom}
                  style={{ display: 'flex' }}
               >

                  {(role === 'ROLE_PARTNER') && <div style={{ display: 'flex', gap: '20px' }}
                  // className={css.partnerConfirm}
                  >
                     {(workPlan?.status === 'new' || workPlan?.status === 'rejected'

                     ) &&
                        <CButton
                           color='info'
                           onClick={() => partnerConfirmToSendToVerify(workPlan.id)}
                        >На перевірку</CButton>}

                     {workPlan?.status === 'verified' && <CButton color='success'>
                        Підтверджено{' '}<br />
                        {(workPlan.status === 'verified' && item?.dateConfirm) ? `${dayjs(item.dateConfirm).format('YYYY-MM-DD')}` : ''}
                     </CButton>}
                     {workPlan?.status === 'rejected' && <CButton color='warning'>Відхилено</CButton>}

                     {(workPlan?.status === 'rejected' || workPlan?.status === 'verified') && <div
                        style={{ color: workPlan.status === 'rejected' ? 'red' : 'green' }}
                     >
                        {workPlan?.userComfirmDescription ? workPlan.userComfirmDescription : ''}
                     </div>}

                     {workPlan?.status === 'send-to-verify' && <>
                        <CButton color='success'>На перевірці</CButton>
                        <CButton>Час відправки на перевірку {' '}  {workPlan?.sendToVerifyTime && dayjs
                           (workPlan.sendToVerifyTime)
                           .format("DD.MM.YYYY HH:mm")}</CButton>
                     </>}
                  </div>}


                  {/* блок адміна */}
                  {(role === 'ROLE_ADMIN') && <div style={{ display: 'flex', gap: '20px' }}
                  // className={css.adminConfirm}
                  >
                     {workPlan?.status === 'send-to-verify' && <CButton
                        onClick={() => adminConfirmToSuccess(workPlan.id)}
                        color='info'>Підтвердити</CButton>}
                     {workPlan?.status === 'send-to-verify' && <CButton
                        onClick={() => adminConfirmToRejected(workPlan.id)}
                        color='danger'>Відхилити</CButton>}
                     {workPlan?.status === 'send-to-verify' && <CButton
                     >
                        Час відправки на перевірку {' '}  {workPlan?.sendToVerifyTime && dayjs
                           (workPlan.sendToVerifyTime)
                           .format("DD.MM.YYYY HH:mm")}
                     </CButton>}

                     {/* {workPlan?.status === 'send-to-verify' &&
                                    <CFormTextarea
                                        onChange={(e) => handleComentChange(workPlan.id, e.target.value)}
                                        color='danger'></CFormTextarea>
                                } */}
                     {workPlan?.status === 'verified' && <CButton color='success'>

                        Підтверджено{' '}<br />
                        {(workPlan.status === 'verified' && item.dateConfirm) ? dayjs(item.dateConfirm).format('YYYY-MM-DD') : ''}
                     </CButton>}
                     {workPlan?.status === 'rejected' && <CButton color='warning'>Відхилено</CButton>}
                     {/* {workPlan?.status === 'rejected' &&
                        <CButton
                           color='info'
                           onClick={() => partnerConfirmToSendToVerify(workPlan.id)}
                        >На перевірку</CButton>
                     } */}
                  </div>}
               </div>
               {/* блок для зміни статуса */}


            </div>
         }


      </div >
   );
}
